import React, { Component } from "react";

import { Modal, Button, ButtonGroup, Row, Col, FormGroup, Form, ControlLabel, FormControl, Checkbox, Glyphicon} from "react-bootstrap";
import Switch from 'react-bootstrap-switch';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import Loading from "../../components/loading";
import SettingsModal from "../../components/settings-alert";

import "react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.css";

import "./style.css";

import {ToastContainer, ToastStore} from 'react-toasts';

import UsersService from "../../services/users-service";
import EmailService from "../../services/email-service";
import IncidentService from '../../services/incidents-service';
import UtilsService from '../../services/utils-service';

import CustomTimePicker from '../../components/timepicker';

import Moment from 'react-moment';
import _ from 'underscore';

import { AsYouType } from 'libphonenumber-js';
import DatePicker from 'react-16-bootstrap-date-picker';
import TimePicker from 'react-bootstrap-time-picker';
import { SegmentedControl } from 'segmented-control'

import moment from 'moment';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { EXITED } from "react-transition-group/Transition";


//For Massive Forms. Has better control over text and stuff supposedly.
var pdfMake = require('pdfmake/build/pdfmake.js');
var vfs_fonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = vfs_fonts.pdfMake.vfs;


class LiveNationAddIncident extends Component {

    tableData = {
        columns: [
            {
                label: 'Date',
                field: 'date',
                sort: 'asc',
                width: 350
            },
            {
                label: 'Name',
                field: 'name',
                sort: 'asc',
                width: 350
            },
            {
                label: 'Venue',
                field: 'facility',
                sort: 'asc',
                width: 350
            },
            {
                label: 'Event',
                field: 'event',
                sort: 'asc',
                width: 350
            },
            {
                label: 'Location',
                field: 'facility_location',
                sort: 'asc',
                width: 350
            },
            {
                label: 'Action',
                field: 'status',
                width: 150
            }
        ],
        rows: []
    }

    constructor(props) {
        super(props);

        var user = UsersService.sharedInstance.getStoredCredentials();

        this.state = {
            license: user.license,
            user_auth: user.username,
            token: user.token,
            loginResponse: user.loginResponse,

            message: '',
            isShowing: false,
            showWarningModal: false,
            individual_count: 1,

            dispatch_no: ' - ',
            incident_type_id: '',
            facility_id: '',
            facility_location_id: '',
            location_description: '',
            individuals_data: [{}],
            witnesses:[],
            witnessCount: 2,
            staffWitnesses: [],
            staffWitnessCount: 2,
            external_agency_data: [],
            incident_involved: [],
            auto_email_id: '',
            auto_email_value: '',
            sub_user_id: user.loginResponse.data[0].recno,
            date_added: new Date(),
            files: [],
            linked_files: [],
            time_of_incident: null,
            time_security_arrived: null,
            time_police_arrived: null,
            section: 1,
            type: [],
            offsite_emergency_care: [],

            tab:'guest',
            tabs:{
                guest:true,
                incident:true,
                property:false,
                medical:false,
                police:false,
                refusal: false,
                sign:true
            },
            hasChanged: false,
            showLinkModal: false,
            show_agency_section: false,
            show_email_section: false,
            checkedFireDepartment: false,
            checkedPolice: false,
            checkedAmbulance: false,
            offenders: [],
            search_offender:'',
            isSubmittingIncident: false,
            submitMessage: "Submitting Incident...",

            medical_dispositions: [
                "Transported to Medical Facility",
                "Arrested",
                "Ejected",
                "Released to Parent/Guardian",
                "Released to Venue",
                "Other"
            ],
        }

        // Options for Repeat Offender Search
        this.options = {
            // onRowClick: (row) => { this.fetchIncidentInfo(row.id) },
            hideSizePerPage: true,
            defaultSortName: 'title',  // default sort column name
            defaultSortOrder: 'asc'  // default sort order
        }

        this.linkIncidentOptions = {
            onRowClick: (row) => { },
            hideSizePerPage: true,
            defaultSortName: 'time',  // default sort column name
            defaultSortOrder: 'asc'  // default sort order
        }

        this.list = {
            first_aids:['Offered','Accepted','Declined'],
        }

        this.handleCheckBoxTick = this.handleCheckBoxTick.bind(this);
        this.handleNextButton = this.handleNextButton.bind(this);
        this.handlePrevButton = this.handlePrevButton.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.handleTimeIncidentChanged = this.handleTimeIncidentChanged.bind(this);
        this.handleTimePoliceArrivedChanged = this.handleTimePoliceArrivedChanged.bind(this);
        this.handleTimeSecurityArrivedChanged = this.handleTimeSecurityArrivedChanged.bind(this);

        this.handleTimeGuestArrivedChanged = this.handleTimeGuestArrivedChanged.bind(this);
        this.handleTimeGuestAteChanged = this.handleTimeGuestAteChanged.bind(this);
        this.handleTimeGuestAteAtVenueChanged = this.handleTimeGuestAteAtVenueChanged.bind(this);
        this.handleSubmitIncident = this.handleSubmitIncident.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.getAllRepeatOffenderByName = this.getAllRepeatOffenderByName.bind(this);
        this.sendEmail = this.sendEmail.bind(this);

        this.renderLinkIncidentAction = this.renderLinkIncidentAction.bind(this);

        this.fetchOffenders = this.fetchOffenders.bind(this);
        this.onChangeSearchOffender = this.onChangeSearchOffender.bind(this);

        this.options = {
            onRowClick: (row) => { this.handleLinkFile(row) },
            hideSizePerPage: true,
            defaultSortName: 'title',  // default sort column name
            defaultSortOrder: 'asc'  // default sort order
        }

        this._isMounted = false;
        this.refusal_injured_parts_details = "";
        this.refusal_individual_name = "";
        this.refusal_facility_location = "";
        this.timeout =  0;
    }

    // Render Functions

    render() {
        let searchMessage = this.state.search_offender ? 'No offenders with name containing "' + this.state.search_offender + '" found.' : "Please search for an offender."
        var options = {
            noDataText: searchMessage,
            defaultSortName: 'date',  // default sort column name
            defaultSortOrder: 'desc'
        };
        return (
            <div className="add-user-content">
                <div className="content-div">
                        {this.renderHeaderSection()}
                        {this.renderButtons("top")}
                        {this.renderContents()}
                        {this.renderButtons()}
                        {this.renderLinkModal()}
                </div>
                <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
                <SettingsModal isShowing={this.state.showWarningModal} cancelButton={this.handleExitButton} continueButton={this.handleContinueButton}/>

                <Modal dialogClassName="repeat-offender-modal" style={{marginTop: "10%"}} show={this.state.showRepeatOffender}>
                    <Modal.Body className="warning-body">
                        <h1 className="warning-header">Search Individuals</h1>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <FormControl
                                        type='text'
                                        value={this.state.search_offender}
                                        onChange={this.onChangeSearchOffender}
                                        placeholder='Enter name of offender...'
                                    />
                                </FormGroup>

                            </Col>
                        </Row>

                        <BootstrapTable options={options} width="100%" data={ this.state.offenders } hover={true} keyField='name' pagination trClassName={"usersRow"}>
                            <TableHeaderColumn dataField='date' width="15%">Date</TableHeaderColumn>
                            <TableHeaderColumn dataField='name' width="15%">Name</TableHeaderColumn>
                            <TableHeaderColumn dataField='facility_name' width="15%">Venue</TableHeaderColumn>
                            <TableHeaderColumn dataField='event_name' width="15%">Event</TableHeaderColumn>
                            <TableHeaderColumn dataField='location_name' width="20%">Location</TableHeaderColumn>
                            <TableHeaderColumn width="10%" dataFormat={this.renderOffenderActions}>Action</TableHeaderColumn>
                        </BootstrapTable>

                        <div className="modal-buttons">
                            <Button className="red-btn" onClick={() => {this.setState({showRepeatOffender: false})}}>Close</Button>
                        </div>
                    </Modal.Body>
                </Modal>
                { <Loading isShowing={this.state.isSubmittingIncident} message={this.state.submitMessage}/>}
            </div>
        )
    }

    renderOffenderActions = (cell,row) => {
        return (
            <Button onClick={() => this.onAddOffender(row)}>Link</Button>
        )
    }

    onAddOffender = (data) =>{
        const {individuals_data} = this.state;

        individuals_data.push(data);

        this.setState({
            individuals_data,
            showRepeatOffender:false,
            offenders:[],
            search_offender:''
        });
    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        var index = 0;
        var newWitnesses = [];

        while(index < this.state.witnessCount) {
            newWitnesses.push({
                name: "",
                phone: "",
                relationship: "",
                address: "",
                description: "",
            });
            index++;
        }

        index = 0;
        var newStaffWitnesses = [];

        while(index < this.state.staffWitnessCount) {
            newStaffWitnesses.push({
                detail: "",
            });
            index++;
        }


        this.setState({
            witnesses: newWitnesses,
            staffWitnesses: newStaffWitnesses
        })

        if(this.props.itemToEdit != null) {
            this.prepForEdit();
        }

        // let params = {
        //     "emails" : ["ena@archontech.com", "ena@codev.com"],
        //     "file": null
        // }
        // this.sendEmail(params);
        this.fetchOffenders(); //initialize
    }

    renderHeaderSection(){

        let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        Date.prototype.formattedTime = function(){
            var h = this.getHours();
            var m = this.getMinutes();
            var ampm = h<12 && m <= 59 ? "AM" : "PM";
            h = h>12 ? h-12 : (h == 0 ? 12 : h);
            m = m<10 ? ('0'+m) : m;

            return h+':'+m+' '+ampm;
        }

        var month = months[this.state.date_added.getMonth()];
        var date = month + " " + this.state.date_added.getDate() + ", " + this.state.date_added.getFullYear();
        var time = this.state.date_added.formattedTime();

        var title = this.props.itemToEdit ? "Edit Incident Data" : "Create New Live Nation Incident Report";

        return(
            <div className="incident-header">
                <div className="incident-title">
                    <h1 className="orange-title left">{title}</h1>
                </div>
                <div className="incident-dispatch-info">
                    <div className="incident-date-block">
                        <h5 className="incident-card-text">Date</h5>
                        {/* <Button className="incident-edit-button">Edit</Button> */}
                        <h5 className="dispatch-date-value">{date}</h5>
                        <h5 className="dispatch-date-value">@ {time}</h5>
                    </div>
                </div>
            </div>
        )
    }

    renderContents(){
        const {tab} = this.state;

        if (tab === 'incident'){
            return this.renderIncidentDetails();
        }
        else if (tab === 'guest'){
            return this.renderGuestQuestions();
        }
        else if (tab === 'property'){
            return this.renderPropertyDamage();
        }
        else if (tab === 'medical'){
            return this.renderMedical();
        }
        else if (tab === 'police'){
            return this.renderPoliceSection();
        }
        else if (tab === 'refusal'){
            return this.renderRefusalSection();
        }
        else if (tab === 'sign'){
            return this.renderSignAndAssets();
        }
    }

    renderIncidentDetails(){

        let hasFacilityLocations = this.props.facility_locations ? true : false;
        let hasFacilities = this.props.facilities ? true : false;
        let hasEvents = this.props.events ? true : false;

        let facility_locations = this.props.facility_locations;
        let facilities = this.props.facilities;
        let events = this.props.events;

        let incidentsInvolved = this.state.incident_involved ? this.state.incident_involved : [];
        let incidentsType = this.state.type ? this.state.type : [];

        return (
            <div className="incident-section">
                <h3 className="sub-title">Incident Information</h3>
                <hr className="line"/>

                <div className="left-side-content">
                    <ControlLabel className="login_label">Incident Type</ControlLabel>

                    <div className="live-nation-incident-type-div">
                        <Checkbox
                            id="Medical"
                            name="Medical"
                            inline
                            value='medical'
                            checked={incidentsType.includes("Medical")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "type")}>Medical</Checkbox>

                        <Checkbox
                            id="Police/Security"
                            name="Police/Security"
                            inline
                            value='police'
                            checked={incidentsType.includes("Police/Security")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "type")}>Police/Security</Checkbox>

                        <Checkbox
                            id="Property Damage"
                            name="Property Damage"
                            inline
                            value='property'
                            checked={incidentsType.includes("Property Damage")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "type")}>Property Damage</Checkbox>
                    </div>

                    <FormGroup controlId="facility" bsSize="sm">
                        <ControlLabel className="login_label">Venue Name</ControlLabel>
                        <FormControl  componentClass="select" placeholder="Use Dropdown"
            							style={{width: "100%"}}
            							value={this.state.facility_id}
            							onChange={(e)=>{this.setState({facility_id: e.target.value})}}>
                                {hasFacilities ? <option value={"select"}>Select Venue</option> : null}
                                {hasFacilities
                                    ? facilities.map((facility) => {
                                            if(facility.is_active == 1)
                                                return <option key={facility.facility_id} value={facility.facility_id}>{facility.facility_name}</option>
                                        })
                                    : <option disabled value="select">No Venue Available</option>
                                }
                        </FormControl>
                    </FormGroup>


                    <FormGroup controlId="address" bsSize="sm">
                        <ControlLabel className="login_label">Address</ControlLabel>
                        <FormControl
                            type="text"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "address", null)}
                                      }
                            value={this.state.address ? this.state.address : ""}
                        />
                    </FormGroup>

                    <FormGroup controlId="event" bsSize="sm">
                        <ControlLabel className="login_label">Event Name</ControlLabel>
                        <FormControl  componentClass="select" placeholder="Use Dropdown"
                           style={{width: "100%"}}
                           value={this.state.event_id}
                           onChange={(e)=>{this.setState({event_id: e.target.value})}}>
                                {hasEvents ? <option value={"select"}>Select Event</option> : null}
                                {hasEvents
                                    ? events.map((event) => {
                                            if(event.is_active == 1)
                                                return <option key={event.event_id} value={event.event_id}>{event.event_name}</option>
                                        })
                                    : <option disabled value="select">No Events Available</option>
                                }
                        </FormControl>
                    </FormGroup>

                    <FormGroup controlId="facility_location_id" bsSize="sm">
                        <ControlLabel className="login_label">Location</ControlLabel>
                        <FormControl  componentClass="select" placeholder="Use Dropdown"
                           style={{width: "100%"}}
                           value={this.state.facility_location_id}
                           onChange={(e)=>{this.setState({facility_location_id: e.target.value})}}>
                                {hasFacilityLocations ? <option value={"select"}>Select Location</option> : null}
                                {hasFacilityLocations && facility_locations.length > 0
                                    ? facility_locations.map((location) => {
                                            if(location.is_active == 1)
                                                return <option key={location.facility_location_id} value={location.facility_location_id}>{location.location_name}</option>
                                        })
                                    : <option disabled value="select">No Location</option>
                                }
                        </FormControl>
                    </FormGroup>

                    <FormGroup controlId="location_desc" bsSize="sm">
                                <ControlLabel className="login_label">Provide specific details on the location</ControlLabel>
                                <FormControl
                                    key="location_desc"
                                    type="text"
                                    onChange={(e)=>{
                                                this.handleChange(e, e.target.value, null, "location_desc", null)}
                                              }
                                    value={this.state.location_desc}
                                />
                    </FormGroup>

                    <FormGroup controlId="occupancy" bsSize="sm">
                        <ControlLabel className="login_label">Occupancy</ControlLabel>
                        <div className="live-nation-incident-type-div">
                            <Checkbox
                                id="Full Capacity"
                                name="Full Capacity"
                                inline
                                checked={this.state.occupancy === "Full Capacity"}
                                onChange={(e)=> {this.setState({occupancy: "Full Capacity"})}}>Full Capacity</Checkbox>
                            <Checkbox
                                id="3/4 Capacity"
                                name="3/4 Capacity"
                                inline
                                checked={this.state.occupancy === "3/4 Capacity"}
                                onChange={(e)=> {this.setState({occupancy: "3/4 Capacity"})}}>3/4 Capacity</Checkbox>
                            <Checkbox
                                id="Sparse"
                                name="Sparse"
                                inline
                                checked={this.state.occupancy === "Sparse"}
                                onChange={(e)=> {this.setState({occupancy: "Sparse"})}}>Sparse</Checkbox>

                            <Checkbox
                                id="Other"
                                name="Other"
                                inline
                                checked={this.state.occupancy === "Other"}
                                onChange={(e)=> {this.setState({occupancy: "Other"})}}>Other</Checkbox>
                         </div>
                    </FormGroup>

                    <FormGroup controlId="occupancy_other" bsSize="sm">
                                <ControlLabel className="login_label">If other, please explain</ControlLabel>
                                <FormControl
                                    key="occupancy_other"
                                    type="text"
                                    disabled={this.state.occupancy == null || this.state.occupancy !== "Other"}
                                    onChange={(e)=>{
                                                this.handleChange(e, e.target.value, null, "occupancy_other", null)}
                                              }
                                    value={this.state.occupancy_other}
                                />
                    </FormGroup>

                    <div className="spacer"></div>

                    Lighting Conditions

                    <div className="spacer"></div>

                    <FormGroup bsSize="sm">
                                <ControlLabel className="login_label">Club</ControlLabel>
                                <FormControl
                                    id="lighting_club"
                                    key="lighting_club"
                                    type="text"
                                    onChange={(e)=>{
                                                this.handleChange(e, e.target.value, null, "lighting_club", null)}
                                              }
                                    value={this.state.lighting_club}
                                />

                                <ControlLabel className="login_label">Restaurant</ControlLabel>
                                <FormControl
                                    id="lighting_restaurant"
                                    key="lighting_restaurant"
                                    type="text"
                                    onChange={(e)=>{
                                                this.handleChange(e, e.target.value, null, "lighting_restaurant", null)}
                                              }
                                    value={this.state.lighting_restaurant}
                                />

                                <ControlLabel className="login_label">Exterior</ControlLabel>
                                <FormControl
                                    id="lighting_exterior"
                                    key="lighting_exterior"
                                    type="text"
                                    onChange={(e)=>{
                                                this.handleChange(e, e.target.value, null, "lighting_exterior", null)}
                                              }
                                    value={this.state.lighting_exterior}
                                />

                                <ControlLabel className="login_label">Burned Out/Missing</ControlLabel>
                                <FormControl
                                    id="lighting_burned_out"
                                    key="lighting_burned_out"
                                    type="text"
                                    onChange={(e)=>{
                                                this.handleChange(e, e.target.value, null, "lighting_burned_out", null)}
                                              }
                                    value={this.state.lighting_burned_out}
                                />


                    </FormGroup>

                    <FormGroup controlId="location_observation" bsSize="sm">
                        <ControlLabel className="login_label">Other observations or specific details regarding the location</ControlLabel>
                        <FormControl
                            key="location_observation"
                            componentClass="textarea"
                            rows={4}
                            placeholder="Enter witness description..."
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "location_observation", null)}
                                      }
                            value={this.state.location_observation}
                        />
                    </FormGroup>

                </div>

                <div className="right-side-content">
                    <div className="half-width">
                        <ControlLabel className="left-form-label">Time of Incident</ControlLabel>
                        <CustomTimePicker id='time_of_incident' value={this.state.time_of_incident} onChange={this.handleTimeIncidentChanged}  />
                    </div>
                    <div className="half-width">
                        <ControlLabel className="left-form-label">Time Security Arrived</ControlLabel>
                        <CustomTimePicker id='time_security_arrived' value={this.state.time_security_arrived} onChange={this.handleTimeSecurityArrivedChanged}  />
                    </div>
                    <div className="half-width">
                        <ControlLabel className="left-form-label">Time Emergency/Police Arrived</ControlLabel>
                        <CustomTimePicker id='time_police_arrived' value={this.state.time_police_arrived} onChange={this.handleTimePoliceArrivedChanged}  />
                    </div>

                    <ControlLabel className="login_label">Incident Involves</ControlLabel>
                    <div className="incident_involved">
                        <Checkbox
                            id="Guest"
                            name="Guest"
                            inline
                            checked={incidentsInvolved.includes("Guest")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "incident_involved")}>Guest</Checkbox>

                        <Checkbox
                            id="Band"
                            name="Band"
                            inline
                            checked={incidentsInvolved.includes("Band")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "incident_involved")}>Band</Checkbox>

                        <Checkbox
                            id="Crew"
                            name="Crew"
                            inline
                            checked={incidentsInvolved.includes("Crew")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "incident_involved")}>Crew</Checkbox>

                        <Checkbox
                            id="Vendor"
                            name="Vendor"
                            inline
                            checked={incidentsInvolved.includes("Vendor")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "incident_involved")}>Vendor</Checkbox>
                    </div>
                    <div className="live-nation-incident-type-div">
                        <Checkbox
                            id="Property Damage"
                            name="Property Damage"
                            inline
                            checked={incidentsInvolved.includes("Property Damage")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "incident_involved")}>Property Damage</Checkbox>

                        <Checkbox
                            id="Theft"
                            name="Theft"
                            inline
                            checked={incidentsInvolved.includes("Theft")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "incident_involved")}>Theft</Checkbox>

                        <Checkbox
                            id="Other"
                            name="Other"
                            inline
                            checked={incidentsInvolved.includes("Other")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "incident_involved")}>Other*</Checkbox>
                    </div>

                    <FormGroup controlId="tape_on_file">
                        <ControlLabel className="left-form-label">Tape on File</ControlLabel>
                        <Switch
                            onText = "YES"
                            offText = "NO"
                            defaultValue={false}
                            value = {this.state.tape_on_file}
                            onChange={(el, state)=>{
                                        var fakeEvent = {target: { id: "tape_on_file", value: state}};
                                        this.handleChange(fakeEvent, state, null, fakeEvent.target.id, null)}
                                      }
                            name='tape_on_file'
                        />
                    </FormGroup>

                    <div className="spacer"></div>

                    <FormGroup controlId="email_incident_div">
                        <h3 className="sub-title section-title-with-toggle">Email Incident?</h3>
                        <Switch
                                onText = "ON"
                                offText = "OFF"
                                value = {this.state.show_email_section}
                                onChange={(el, state)=>{
                                            var fakeEvent = {target: { id: "show_email_section", value: state}};
                                            this.handleChange(fakeEvent, state, null, fakeEvent.target.id, null)
                                            this.setState({auto_email_id: ""})
                                          }
                                          }
                                name='show_email_section'
                        />
                    </FormGroup>
                    <div className="spacer"></div>

                    {this.renderEmailSectionContents()}

                </div>
            </div>
        )
    }

    renderEmailSectionContents(){
        let hasAutoEmails =  this.props.auto_emails && this.props.auto_emails.length > 0 ? true : false;
        let auto_emails = this.props.auto_emails;

        if (this.state.show_email_section == false){
            return (
                <div className="section-content"></div>
            )
        }

        return (  <div className="section-content">
                      <FormGroup controlId="email_address" bsSize="sm">
                      <ControlLabel className="login_label">Send Email to:</ControlLabel>
                      <FormControl
                          type="text"
                          onChange={(e)=>{
                                    this.setState({
                                      autoEmails: [e.target.value]
                                    })}
                                    }
                          value={this.state.autoEmails != null && this.state.autoEmails.length > 0 ? this.state.autoEmails[0] : ""}
                      />
                      </FormGroup>
                  </div>)
        return (
            <div className="section-content">
                <hr className="line"/>
                <FormGroup controlId="emai_address" bsSize="sm">
                    <ControlLabel className="login_label">Email Address <span className="gray-text">(will send a PDF Report)</span></ControlLabel>
                    <FormControl  componentClass="select" placeholder="Use Dropdown"
                        style={{width: "100%"}}
                        value={this.state.autoEmails != null && this.state.autoEmails.length > 0 ? this.state.autoEmails[0] : ""}
                        onChange={(e)=>{
                            this.setState({autoEmails: [e.target.value]});
                        }}>
                            {hasAutoEmails ? <option value={""}>Select Auto Email</option> : <option disabled value={""}>No emails</option>}
                            {hasAutoEmails
                                ? auto_emails.map((email) => {
                                    return <option key={email.auto_email_id} value={email.auto_email}>{email.auto_email}</option>
                                    })
                                : <option disabled value="select">No Auto Email</option>
                            }
                    </FormControl>
                </FormGroup>
                <Button className="green-btn" onClick={this.handleAddEmail}>Add an Email</Button>
            </div>
        )
    }

    renderGuestQuestions(){

        let hasFacilityLocations = this.props.facility_locations ? true : false;
        let hasFacilities = this.props.facilities ? true : false;

        let facility_locations = this.props.facility_locations;
        let facilities = this.props.facilities;

        const {individuals_data} = this.state;

        return(
            <div className="incident-section">
                <h3 className="sub-title">Guest Questions</h3>
                <hr className="line"/>

                {
                    individuals_data.map((individual_data,index) => {
                        return this.renderIndividual(individual_data, index);
                    })
                }
                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <Button type='button' className='green-btn' onClick={this.handleAddGuest}>Add Person Manually</Button>
                        </FormGroup>
                        <FormGroup>
                            <Button type='button' className='gray-btn' onClick={this.handleRepeatOffender}>Repeat Offender</Button>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }

    renderSignAndAssets(){
      var linked_files_ids = [];
      this.state.linked_files.map((file)=>{
        if(file != null && file.title) {
          linked_files_ids.push(file.title)
        } else {
          if(file != null) {

            let json_data = [];
            let title = "";
            try{
                json_data = UtilsService.sharedInstance.tryParseJSON(file.individuals_data) ? JSON.parse(file.individuals_data) : [];
                title = UsersService.sharedInstance.returnEmptyIfNull(json_data[0].name);
            }
            catch(e){
                title = "Custom Incident Form - Live Nation";
            }
            file.title = title;

            linked_files_ids.push(file.title);
          } else {

          }

        }

      });

        return (
            <div className="incident-section">
                <h3 className="sub-title">Sign And Assets</h3>
                <hr className="line"/>

                <div className="left-side-content">
                    <FormGroup controlId="additional_observations" bsSize="sm">
                        <ControlLabel className="login_label">Additional Observations or Comments?</ControlLabel>
                        <FormControl
                            key="additional_observations"
                            componentClass="textarea"
                            rows={4}
                            placeholder="Additional comments..."
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "additional_observations", null)}
                                      }
                            value={this.state.additional_observations}
                        />
                    </FormGroup>
                    <FormGroup controlId="investigating_manager_name" bsSize="sm">
                        <ControlLabel className="login_label">Investigating Manager's Name</ControlLabel>
                        <FormControl
                            key="investigating_manager_name"
                            type="text"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "investigating_manager_name", null)}
                                      }
                            value={this.state.investigating_manager_name}
                        />
                    </FormGroup>
                    <FormGroup controlId="investigating_manager_signature" bsSize="sm">
                        <ControlLabel className="login_label">Manager's Signature</ControlLabel>
                        <FormControl
                            key="investigating_manager_signature"
                            type="text"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "investigating_manager_signature", null)}
                                      }
                            value={this.state.investigating_manager_signature}
                        />
                    </FormGroup>
                    <FormGroup controlId="general_manager_name" bsSize="sm">
                        <ControlLabel className="login_label">General Manager's Name</ControlLabel>
                        <FormControl
                            key="general_manager_name"
                            type="text"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "general_manager_name", null)}
                                      }
                            value={this.state.general_manager_name}
                        />
                    </FormGroup>
                    <FormGroup controlId="general_manager_signature" bsSize="sm">
                        <ControlLabel className="login_label">General Manager's Signature</ControlLabel>
                        <FormControl
                            key="general_manager_signature"
                            type="text"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "general_manager_signature", null)}
                                      }
                            value={this.state.general_manager_signature}
                        />
                    </FormGroup>

                    <FormGroup>
                        <div className="attachments-div">
                            {
                               this.state.files.map((file,key) => {
                                    const {name,type} = file;
                                    try{

                                        const url = URL.createObjectURL(file);

                                        if(type.indexOf('video') === -1){
                                            return <img key={key} className="attachment-image" src={url} width={100} height={70} alt={name} />
                                        }else{
                                            return (
                                                <video width={100} height={70} key={key}>
                                                    <source src={url} type={type}></source>
                                                </video>
                                            )
                                        }
                                    }
                                    catch(e){
                                        return <img key={key} className="attachment-image" src={file.path} width={100} height={70} alt={name} />
                                    }
                                })
                            }
                        </div>
                    </FormGroup>

                    <FormGroup>
                        <input type="file" id="file" ref="fileUploader" accept='image/*,video/*' style={{display: "none"}} onChange={this.handleFileChange}/>
                        <Button className="green-btn" onClick={this.handleAddFile}>Add Image / Video</Button>
                    </FormGroup>

                    <FormGroup controlId="link_files" bsSize="sm">
                        <Button className="green-btn" onClick={()=>{this.setState({showLinkModal: !this.state.showLinkModal})}}>Link Files</Button>
                    </FormGroup>

                    <FormGroup>
                        <div className="attachments-div">
                            {
                              linked_files_ids.map((name, i)=>{
                                  return <div key={name +"_"+i}>{name} <div className="pull-right"><Glyphicon
                                      glyph="remove"
                                      className="pull-right"
                                      style={{cursor: "pointer", marginLeft: 10}}
                                      onClick={()=>{
                                        var newLinkedFiles = this.state.linked_files.slice();
                                        newLinkedFiles.splice(i, 1);
                                        this.setState({
                                          linked_files: newLinkedFiles
                                        })
                                      }}
                                  /></div></div>
                              })
                            }
                        </div>
                    </FormGroup>

                </div>
            </div>
        )
    }

    renderPropertyDamage() {
        return (
            <div className="incident-section">
                <h3 className="sub-title">Property Damage</h3>
                <hr className="line"/>

                <p className="warning-paragraph">*** Please take photographs to support report - send to Risk Management. ***</p>

                <div className="left-side-content">
                    <FormGroup controlId="asset_damage" bsSize="sm">
                        <ControlLabel className="login_label">Describe specific asset damage (fire, water, leak, etc.) and circumstances</ControlLabel>
                        <FormControl
                            componentClass="textarea"
                            rows={4}
                            placeholder="Describe property damage and circumstances..."
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "asset_damage", null)}
                                      }
                            value={this.state.asset_damage}
                        />
                    </FormGroup>

                    <FormGroup controlId="damage_value">
                        <ControlLabel className="login_label">Estimated value of damage</ControlLabel>
                        <div className="live-nation-incident-type-div">
                            <Checkbox
                                id="checkedDamageValueOne"
                                name="checkedDamageValueOne"
                                inline
                                checked={this.state.damage_value === "< $5,000" ? true : false}
                                onChange={(e)=> {this.setState({damage_value: "< $5,000"})}}>{"< $5,000"}</Checkbox>

                            <Checkbox
                                id="checkedDamageValueTwo"
                                name="checkedDamageValueTwo"
                                inline
                                checked={this.state.damage_value === "$5,000 - $10,000" ? true : false}
                                onChange={(e)=> {this.setState({damage_value: "$5,000 - $10,000"})}}>{"$5,000 - $10,000"}</Checkbox>
                        </div>
                        <div className="live-nation-incident-type-div">
                            <Checkbox
                                id="checkedDamageValueThree"
                                name="checkedDamageValueThree"
                                inline
                                checked={this.state.damage_value === "$10,000 - $20,000" ? true : false}
                                onChange={(e)=> {this.setState({damage_value: "$10,000 - $20,000"})}}>{"$10,000 - $20,000"}</Checkbox>

                            <Checkbox
                                id="checkedDamageValueFour"
                                name="checkedDamageValueFour"
                                inline
                                checked={this.state.damage_value === "> $20,000" ? true : false}
                                onChange={(e)=> {this.setState({damage_value: "> $20,000"})}}>{"> $20,000"}</Checkbox>

                        </div>
                    </FormGroup>

                    <FormGroup controlId="immediate_mediation">
                        <ControlLabel className="left-form-label">Immediate mediation required?</ControlLabel>
                        <Switch
                            onText = "YES"
                            offText = "NO"
                            defaultValue={false}
                            value = {this.state.immediate_mediation}
                            onChange={(el, state)=>{
                                        var fakeEvent = {target: { id: "immediate_mediation", value: state}};
                                        this.handleChange(fakeEvent, state, null, fakeEvent.target.id, null)}
                                      }
                            name='immediate_mediation'
                        />
                    </FormGroup>

                    <div className="spacer"></div>

                    <FormGroup controlId="contractor_dispatch" bsSize="sm">
                        <ControlLabel className="login_label">Contractor Dispatched</ControlLabel>
                        <FormControl
                            type="text"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "contractor_dispatch", null)}
                                      }
                            value={this.state.contractor_dispatch}
                        />
                    </FormGroup>

                    <FormGroup controlId="property_other_details" bsSize="sm">
                        <ControlLabel className="login_label">Other Details</ControlLabel>
                        <FormControl
                            componentClass="textarea"
                            rows={4}
                            placeholder="Describe other property damage details..."
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "property_other_details", null)}
                                      }
                            value={this.state.property_other_details}
                        />
                    </FormGroup>

                    {
                    //   <FormGroup controlId="auto_submit_damage_report">
                    //     <ControlLabel className="left-form-label">Auto-Submit copies of property damage reports to: janberger@livenation.com - Call (323) 769-4347 if damage > $5,000.</ControlLabel>
                    //     <Switch
                    //         onText = "YES"
                    //         offText = "NO"
                    //         value = {this.state.auto_submit_damage_report}
                    //         onChange={(el, state) => this.handleSwitch(el, state)}
                    //         name='auto_submit_damage_report'
                    //     />
                    // </FormGroup>
                  }
                </div>
            </div>
        )
    }

    renderMedical() {

        const {first_aids} = this.list;
        const {tabs, offsite_emergency_care} = this.state;
        return(
            <div className="incident-section">
                <h3 className="sub-title">Medical</h3>
                <hr className="line"/>

                <p className="warning-paragraph">*** If in-house of external medical treatment declined, please have guest sign a Declinations & Release Form - Forward Emergency Medical Treatment reports and Release forms to Risk Managment ***</p>

                <div className="left-side-content">
                  <FormGroup controlId="first_aid">
                      <ControlLabel className="left-form-label">Venue First Aid (ice pack, band-aid, etc.)</ControlLabel>
                      <div className="live-nation-incident-type-div">
                      {
                          (first_aids).map((value, key) => {
                              return (
                                  <Checkbox
                                      key={key}
                                      id={value}
                                      name={value}
                                      inline
                                      checked={this.state.first_aid === value}
                                      onChange={(e)=> {
                                        if (e.target.name == "Declined"){
                                              tabs['refusal'] = true;
                                          } else {
                                              tabs['refusal'] = false;
                                          }
                                          this.setState({first_aid: value, tabs : tabs})}}>
                                  {value}
                                  </Checkbox>
                              )
                          })
                      }
                      </div>
                  </FormGroup>

                    <div className="spacer"></div>

                    <FormGroup controlId="paramedics_called">
                        <ControlLabel className="left-form-label">Paramedics called?</ControlLabel>
                        <Switch
                            onText = "Yes"
                            offText = "No"
                            defaultValue={false}
                            value = {this.state.paramedics_called}
                            onChange={(el, state)=>{
                                        var fakeEvent = {target: { id: "paramedics_called", value: state}};
                                        this.handleChange(fakeEvent, state, null, fakeEvent.target.id, null)}
                                      }
                            name='paramedics_called'
                        />
                    </FormGroup>

                    {/* <div className="spacer"></div>

                    <FormGroup controlId="offsite_emergency_care">
                        <ControlLabel className="left-form-label">Offsite Emergency Care</ControlLabel>
                        <div className="live-nation-incident-type-div">
                            <Checkbox
                                id="Accepted"
                                name="Accepted"
                                inline
                                checked={offsite_emergency_care.includes("Accepted")}
                                onChange={(e)=> this.handleCheckBoxTick(e, "offsite_emergency_care")}>Accepted</Checkbox>

                            <Checkbox
                                id="Declined"
                                name="Declined"
                                inline
                                checked={offsite_emergency_care.includes("Declined")}
                                onChange={(e)=> this.handleCheckBoxTick(e, "offsite_emergency_care")}>Declined</Checkbox>

                              <Checkbox
                                  id="Offered"
                                  name="Offered"
                                  inline
                                  checked={offsite_emergency_care.includes("Offered")}
                                  onChange={(e)=> this.handleCheckBoxTick(e, "offsite_emergency_care")}>Offered</Checkbox>
                        </div>
                    </FormGroup> */}

                    <div className="spacer"></div>

                    <FormGroup controlId="transported_by">
                        <ControlLabel className="login_label">If treated offsite, transported by?</ControlLabel>
                        <div className="live-nation-incident-type-div">
                            <Checkbox
                                id="Ambulance"
                                name="Ambulance"
                                inline
                                disabled={!this.state.offsite_emergency_care}
                                checked={this.state.transported_by === "Ambulance"}
                                onChange={(e)=> {this.setState({transported_by: "Ambulance"})}}>Ambulance</Checkbox>

                            <Checkbox
                                id="Police"
                                name="Police"
                                inline
                                disabled={!this.state.offsite_emergency_care}
                                checked={this.state.transported_by === "Police"}
                                onChange={(e)=> {this.setState({transported_by: "Police"})}}>Police</Checkbox>

                            <Checkbox
                                id="Taxi"
                                name="Taxi"
                                inline
                                disabled={!this.state.offsite_emergency_care}
                                checked={this.state.transported_by === "Taxi"}
                                onChange={(e)=> {this.setState({transported_by: "Taxi"})}}>Taxi</Checkbox>

                            <Checkbox
                                id="Personal"
                                name="Personal"
                                inline
                                disabled={!this.state.offsite_emergency_care}
                                checked={this.state.transported_by === "Personal"}
                                onChange={(e)=> {this.setState({transported_by: "Personal"})}}>Personal</Checkbox>

                            <Checkbox
                                id="Other"
                                name="Other"
                                inline
                                disabled={!this.state.offsite_emergency_care}
                                checked={this.state.transported_by === "Other"}
                                onChange={(e)=> {this.setState({transported_by: "Other"})}}>Other</Checkbox>
                        </div>
                    </FormGroup>

                    <FormGroup controlId="transported_others" bsSize="sm">
                        <ControlLabel className="login_label">If other, please explain</ControlLabel>
                        <FormControl
                            key="transported_others"
                            type="text"
                            disabled={!(this.state.transported_by === "Other")|| !this.state.offsite_emergency_care}
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "transported_others", null)}
                                      }
                            value={this.state.transported_others}
                        />
                    </FormGroup>

                    <FormGroup controlId="transported_to" bsSize="sm">
                        <ControlLabel className="login_label">Transported to</ControlLabel>
                        <FormControl
                            key="transported_to"
                            type="text"
                            disabled={!this.state.offsite_emergency_care}
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "transported_to", null)}
                                      }
                            value={this.state.transported_to}
                        />
                    </FormGroup>

                    <hr className="line"/>

                    {this.renderInjuredBodyParts()}

                    <hr className="line"/>

                    {this.renderRightSide()}

                    <hr className="line"/>

                    {this.renderLeftSide()}
                </div>

                <div className="right-side-content">
                    {this.renderObservations()}
                </div>

            </div>
        )
    }

    renderInjuredBodyParts() {
      var injured_body = this.state.injured_body ? this.state.injured_body : [];

        return (
            <FormGroup controlId="injured_body">
                <ControlLabel className="div-header">Injured Body Part(s)</ControlLabel>
                <div className="live-nation-incident-type-div">
                    <Checkbox
                        id="Head"
                        name="Head"
                        inline
                        checked={injured_body.includes("Head")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_body")}>Head</Checkbox>

                    <Checkbox
                        id="Face"
                        name="Face"
                        inline
                        checked={injured_body.includes("Face")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_body")}>Face</Checkbox>

                    <Checkbox
                        id="Forehead"
                        name="Forehead"
                        inline
                        checked={injured_body.includes("Forehead")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_body")}>Forehead</Checkbox>

                    <Checkbox
                        id="Torso"
                        name="Torso"
                        inline
                        checked={injured_body.includes("Torso")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_body")}>Torso</Checkbox>

                    <Checkbox
                        id="Nose"
                        name="Nose"
                        inline
                        checked={injured_body.includes("Nose")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_body")}>Nose</Checkbox>
                </div>
                <div className="live-nation-incident-type-div">
                    <Checkbox
                        id="Lips"
                        name="Lips"
                        inline
                        checked={injured_body.includes("Lips")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_body")}>Lips</Checkbox>

                    <Checkbox
                        id="Teeth"
                        name="Teeth"
                        inline
                        checked={injured_body.includes("Teeth")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_body")}>Teeth</Checkbox>

                    <Checkbox
                        id="Neck"
                        name="Neck"
                        inline
                        checked={injured_body.includes("Neck")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_body")}>Neck</Checkbox>

                    <Checkbox
                        id="Other"
                        name="Other"
                        inline
                        checked={injured_body.includes("Other")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_body")}>Other</Checkbox>
                </div>
            </FormGroup>
        )
    }

    renderRightSide() {
        var injured_right = this.state.injured_right ? this.state.injured_right : [];
        return (
            <FormGroup controlId="injured_right">
                <ControlLabel className="div-header">Right Side</ControlLabel>
                <div className="live-nation-incident-type-div">
                    <Checkbox
                        id="Eye"
                        name="Eye"
                        inline
                        checked={injured_right.includes("Eye")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_right")}>Eye</Checkbox>

                    <Checkbox
                        id="Cheek"
                        name="Cheek"
                        inline
                        checked={injured_right.includes("Cheek")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_right")}>Cheek</Checkbox>

                    <Checkbox
                        id="Shoulder"
                        name="Shoulder"
                        inline
                        checked={injured_right.includes("Shoulder")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_right")}>Shoulder</Checkbox>

                    <Checkbox
                        id="Arm"
                        name="Arm"
                        inline
                        checked={injured_right.includes("Arm")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_right")}>Arm</Checkbox>

                    <Checkbox
                        id="Hand"
                        name="Hand"
                        inline
                        checked={injured_right.includes("Hand")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_right")}>Hand</Checkbox>

                </div>
                <div className="live-nation-incident-type-div">
                    <Checkbox
                        id="Finger(s)"
                        name="Finger(s)"
                        inline
                        checked={injured_right.includes("Finger(s)")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_right")}>Finger(s)</Checkbox>

                    <Checkbox
                        id="Hip"
                        name="Hip"
                        inline
                        checked={injured_right.includes("Hip")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_right")}>Hip</Checkbox>

                    <Checkbox
                        id="Thigh"
                        name="Thigh"
                        inline
                        checked={injured_right.includes("Thigh")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_right")}>Thigh</Checkbox>

                    <Checkbox
                        id="Knee"
                        name="Knee"
                        inline
                        checked={injured_right.includes("Knee")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_right")}>Knee</Checkbox>

                    <Checkbox
                        id="Shin"
                        name="Shin"
                        inline
                        checked={injured_right.includes("Shin")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_right")}>Shin</Checkbox>

                </div>

                <div className="live-nation-incident-type-div">
                    <Checkbox
                        id="Foot/Ankle"
                        name="Foot/Ankle"
                        inline
                        checked={injured_right.includes("Foot/Ankle")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_right")}>Foot/Ankle</Checkbox>

                    <Checkbox
                        id="Toes"
                        name="Toes"
                        inline
                        checked={injured_right.includes("Toes")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_right")}>Toes</Checkbox>
                </div>

            </FormGroup>
        )
    }

    renderLeftSide() {
        var injured_left = this.state.injured_left ? this.state.injured_left : [];
        return (
            <FormGroup controlId="injured_left">
                <ControlLabel className="div-header">Left Side</ControlLabel>
                <div className="live-nation-incident-type-div">
                    <Checkbox
                        id="Eye"
                        name="Eye"
                        inline
                        checked={injured_left.includes("Eye")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_left")}>Eye</Checkbox>

                    <Checkbox
                        id="Cheek"
                        name="Cheek"
                        inline
                        checked={injured_left.includes("Cheek")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_left")}>Cheek</Checkbox>

                    <Checkbox
                        id="Shoulder"
                        name="Shoulder"
                        inline
                        checked={injured_left.includes("Shoulder")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_left")}>Shoulder</Checkbox>

                    <Checkbox
                        id="Arm"
                        name="Arm"
                        inline
                        checked={injured_left.includes("Arm")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_left")}>Arm</Checkbox>

                    <Checkbox
                        id="Hand"
                        name="Hand"
                        inline
                        checked={injured_left.includes("Hand")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_left")}>Hand</Checkbox>

                </div>
                <div className="live-nation-incident-type-div">
                    <Checkbox
                        id="Finger(s)"
                        name="Finger(s)"
                        inline
                        checked={injured_left.includes("Finger(s)")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_left")}>Finger(s)</Checkbox>

                    <Checkbox
                        id="Hip"
                        name="Hip"
                        inline
                        checked={injured_left.includes("Hip")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_left")}>Hip</Checkbox>

                    <Checkbox
                        id="Thigh"
                        name="Thigh"
                        inline
                        checked={injured_left.includes("Thigh")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_left")}>Thigh</Checkbox>

                    <Checkbox
                        id="Knee"
                        name="Knee"
                        inline
                        checked={injured_left.includes("Knee")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_left")}>Knee</Checkbox>

                    <Checkbox
                        id="Shin"
                        name="Shin"
                        inline
                        checked={injured_left.includes("Shin")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_left")}>Shin</Checkbox>

                </div>

                <div className="live-nation-incident-type-div">
                    <Checkbox
                        id="Foot/Ankle"
                        name="Foot/Ankle"
                        inline
                        checked={injured_left.includes("Foot/Ankle")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_left")}>Foot/Ankle</Checkbox>

                    <Checkbox
                        id="Toes"
                        name="Toes"
                        inline
                        checked={injured_left.includes("Toes")}
                        onChange={(e)=> this.handleCheckBoxTick(e, "injured_left")}>Toes</Checkbox>
                </div>

            </FormGroup>
        )
    }

    renderObservations() {

        let hasFacilityLocations = this.props.facility_locations ? true : false;
        let hasFacilities = this.props.facilities ? true : false;

        let facility_locations = this.props.facility_locations;
        let facilities = this.props.facilities;

        let medicalDispositions = this.state.medical_dispositions;
        var observations = this.state.observations ? this.state.observations : [];
        var conditions = this.state.conditions ? this.state.conditions : [];

        return(
            <div>
                <FormGroup controlId="observations">
                    <ControlLabel className="login_label">Observations</ControlLabel>
                    <div className="live-nation-incident-type-div">
                        <Checkbox
                            id="Blood"
                            name="Blood"
                            inline
                            checked={observations.includes("Blood")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Blood</Checkbox>

                        <Checkbox
                            id="Bruising"
                            name="Bruising"
                            inline
                            checked={observations.includes("Bruising")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Bruising</Checkbox>

                        <Checkbox
                            id="Abrasions"
                            name="Abrasions"
                            inline
                            checked={observations.includes("Abrasions")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Abrasions</Checkbox>

                        <Checkbox
                            id="Cut"
                            name="Cut"
                            inline
                            checked={observations.includes("Cut")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Cut</Checkbox>

                    </div>
                    <div className="live-nation-incident-type-div">
                        <Checkbox
                            id="Burn"
                            name="Burn"
                            inline
                            checked={observations.includes("Burn")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Burn</Checkbox>

                        <Checkbox
                            id="Fainting"
                            name="Fainting"
                            inline
                            checked={observations.includes("Fainting")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Fainting</Checkbox>

                        <Checkbox
                            id="Dizziness"
                            name="Dizziness"
                            inline
                            checked={observations.includes("Dizziness")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Dizziness</Checkbox>

                        <Checkbox
                            id="Seizure"
                            name="Seizure"
                            inline
                            checked={observations.includes("Seizure")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Seizure</Checkbox>

                    </div>
                    <div className="live-nation-incident-type-div">
                        <Checkbox
                            id="Vomiting"
                            name="Vomiting"
                            inline
                            checked={observations.includes("Vomiting")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Vomiting</Checkbox>

                        <Checkbox
                            id="Swelling"
                            name="Swelling"
                            inline
                            checked={observations.includes("Bruising")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Swelling</Checkbox>

                        <Checkbox
                            id="Pain"
                            name="Pain"
                            inline
                            checked={observations.includes("Pain")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Pain</Checkbox>

                        <Checkbox
                            id="ETOH"
                            name="ETOH"
                            inline
                            checked={observations.includes("ETOH")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>ETOH</Checkbox>
                    </div>
                    <div className="live-nation-incident-type-div">
                        <Checkbox
                            id="Intoxication"
                            name="Intoxication"
                            inline
                            checked={observations.includes("Intoxication")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Intoxication</Checkbox>

                        <Checkbox
                            id="Drug-Related Behavior"
                            name="Drug-Related Behavior"
                            inline
                            checked={observations.includes("Drug-Related Behavior")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Drug-Related Behavior</Checkbox>

                        <Checkbox
                            id="Other"
                            name="Other"
                            inline
                            checked={observations.includes("Other")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "observations")}>Other</Checkbox>
                    </div>
                </FormGroup>

                <FormGroup controlId="observations_others" bsSize="sm">
                    <ControlLabel className="login_label">If other, please explain</ControlLabel>
                    <FormControl
                        type="text"
                        disabled={(this.state.observations == null || !this.state.observations.includes("Other"))}
                        onChange={(e)=>{
                                    this.handleChange(e, e.target.value, null, "observations_others", null)}
                                  }
                        value={this.state.observations_others}
                    />
                </FormGroup>

                <FormGroup controlId="clothes_contribute">
                    <ControlLabel className="left-form-label">Did clothes / shoes contribute to the accident?</ControlLabel>
                    <Switch
                        onText = "Yes"
                        offText = "No"
                        value = {this.state.clothes_contribute}
                        onChange={(el, state)=>{
                                    var fakeEvent = {target: { id: "clothes_contribute", value: state}};
                                    this.handleChange(fakeEvent, state, null, fakeEvent.target.id, null)}
                                  }
                        name='clothes_contribute'
                    />
                </FormGroup>

                <div className="spacer"></div>

                <FormGroup controlId="conditions">
                    <ControlLabel className="login_label">Condition of the floors / steps</ControlLabel>
                    <div className="live-nation-incident-type-div">
                        <Checkbox
                            id="Wet"
                            name="Wet"
                            inline
                            checked={conditions.includes("Wet")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "conditions")}>Wet</Checkbox>

                        <Checkbox
                            id="Sticky"
                            name="Sticky"
                            inline
                            checked={conditions.includes("Sticky")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "conditions")}>Sticky</Checkbox>

                        <Checkbox
                            id="Clean"
                            name="Clean"
                            inline
                            checked={conditions.includes("Clean")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "conditions")}>Clean</Checkbox>

                        <Checkbox
                            id="Broken Glass"
                            name="Broken Glass"
                            inline
                            checked={conditions.includes("Broken Glass")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "conditions")}>Broken Glass</Checkbox>

                    </div>
                    <div className="live-nation-incident-type-div">
                        <Checkbox
                            id="Obstacles Present"
                            name="Obstacles Present"
                            inline
                            checked={conditions.includes("Obstacles Present")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "conditions")}>Obstacles Present</Checkbox>

                        <Checkbox
                            id="Dry"
                            name="Dry"
                            inline
                            checked={conditions.includes("Dry")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "conditions")}>Dry</Checkbox>

                        <Checkbox
                            id="Greasy"
                            name="Greasy"
                            inline
                            checked={conditions.includes("Greasy")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "conditions")}>Greasy</Checkbox>

                        <Checkbox
                            id="Clear of Debris"
                            name="Clear of Debris"
                            inline
                            checked={conditions.includes("Clear of Debris")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "conditions")}>Clear of Debris</Checkbox>

                    </div>
                    <div className="live-nation-incident-type-div">
                        <Checkbox
                            id="Glassess/Bottles Present"
                            name="Glassess/Bottles Present"
                            inline
                            checked={conditions.includes("Glassess/Bottles Present")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "conditions")}>Glassess/Bottles Present</Checkbox>

                        <Checkbox
                            id="Food on Floor"
                            name="Food on Floor"
                            inline
                            checked={conditions.includes("Food on Floor")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "conditions")}>Food on Floor</Checkbox>

                        <Checkbox
                            id="Other"
                            name="Other"
                            inline
                            checked={conditions.includes("Other")}
                            onChange={(e)=> this.handleCheckBoxTick(e, "conditions")}>Other</Checkbox>
                    </div>
                </FormGroup>

                <FormGroup controlId="condition_other" bsSize="sm">
                    <ControlLabel className="login_label">If other, please explain</ControlLabel>
                    <FormControl
                        componentClass="textarea"
                        rows={4}
                        disabled={(this.state.conditions == null || !this.state.conditions.includes("Other"))}
                        placeholder="Enter more details here..."
                        onChange={(e)=>{
                                    this.handleChange(e, e.target.value, null, "condition_other", null)}
                                  }
                        value={this.state.condition_other}
                    />
                </FormGroup>

                <FormGroup controlId="medical_other_relevant" bsSize="sm">
                    <ControlLabel className="login_label">Note Other Relevant Details</ControlLabel>
                    <FormControl
                        componentClass="textarea"
                        rows={4}
                        placeholder="Enter more details here..."
                        onChange={(e)=>{
                                    this.handleChange(e, e.target.value, null, "medical_other_relevant", null)}
                                  }
                        value={this.state.medical_other_relevant}
                    />
                </FormGroup>

                <FormGroup controlId="medical_disposition" bsSize="sm">
                        <ControlLabel className="login_label">Disposition</ControlLabel>
                        <FormControl  componentClass="select" placeholder="Use Dropdown"
                        style={{width: "100%"}}
                        value={this.state.medical_disposition}
                        onChange={(e)=>{this.setState({medical_disposition: e.target.value})}}>
                                <option value={"select"}>Select Medical Disposition</option>
                                {
                                    medicalDispositions.map((disposition, index) => {
                                        return <option key={index} value={disposition}>{disposition}</option>
                                    })
                                }
                        </FormControl>
                    </FormGroup>

                <FormGroup controlId="medical_other_details" bsSize="sm">
                    <ControlLabel className="login_label">Other Details</ControlLabel>
                    <FormControl
                        componentClass="textarea"
                        rows={4}
                        placeholder="Enter more details here..."
                        onChange={(e)=>{
                                    this.handleChange(e, e.target.value, null, "medical_other_details", null)}
                                  }
                        value={this.state.medical_other_details}
                    />
                </FormGroup>
            </div>
        )
    }

    renderPoliceSection() {

        let hasFacilityLocations = this.props.facility_locations ? true : false;
        let hasFacilities = this.props.facilities ? true : false;

        let facility_locations = this.props.facility_locations;
        let facilities = this.props.facilities;

        return (
            <div className="incident-section">
                <h3 className="sub-title">Police</h3>
                <hr className="line"/>

                <p className="warning-paragraph">*** Attach Copy of Police Incident Report if available. ***</p>

                <div className="left-side-content">
                    <h3 className="div-header">Information Details</h3>
                    <hr className="line"/>

                    <FormGroup controlId="police_called">
                        <ControlLabel className="left-form-label">Police Called?</ControlLabel>
                        <Switch
                            onText = "YES"
                            offText = "NO"
                            defaultValue={false}
                            value = {this.state.police_called}
                            onChange={(el, state)=>{
                                        var fakeEvent = {target: { id: "police_called", value: state}};
                                        this.handleChange(fakeEvent, state, null, fakeEvent.target.id, null)}
                                      }
                            name='police_called'/>
                    </FormGroup>

                    <FormGroup controlId="police_ejected">
                        <ControlLabel className="left-form-label">Was anyone ejected?</ControlLabel>
                        <Switch
                            onText = "YES"
                            offText = "NO"
                            defaultValue={false}
                            value = {this.state.police_ejected}
                            onChange={(el, state)=>{
                                        var fakeEvent = {target: { id: "police_ejected", value: state}};
                                        this.handleChange(fakeEvent, state, null, fakeEvent.target.id, null)}
                                      }
                            name='police_ejected'/>
                    </FormGroup>

                    <div className="spacer"></div>

                    <FormGroup controlId="police_report">
                        <ControlLabel className="left-form-label">Police Report?</ControlLabel>
                        <Switch
                            onText = "YES"
                            offText = "NO"
                            defaultValue={false}
                            value = {this.state.police_report}
                            onChange={(el, state)=>{
                                        var fakeEvent = {target: { id: "police_report", value: state}};
                                        this.handleChange(fakeEvent, state, null, fakeEvent.target.id, null)}
                                      }
                            name='police_report'
                        />
                    </FormGroup>

                    <div className="spacer"></div>

                    <FormGroup controlId="police_officer" bsSize="sm">
                        <ControlLabel className="login_label">Police Report Officer's Name (obtain business & attach)</ControlLabel>
                        <FormControl
                            type="text"
                            key="police_officer"
                            disabled={!this.state.police_report}
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "police_officer", null)}
                                      }
                            value={this.state.police_officer}
                        />
                    </FormGroup>

                    <FormGroup controlId="blood_alcohol" bsSize="sm">
                        <ControlLabel className="login_label">BAC (Blood Alcohol Content)</ControlLabel>
                        <FormControl
                            key="blood_alcohol"
                            type="text"
                            disabled={!this.state.police_report}
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "blood_alcohol", null)}
                                      }
                            value={this.state.blood_alcohol}
                        />
                    </FormGroup>

                    <FormGroup controlId="police_arrested">
                        <ControlLabel className="left-form-label">Was anyone arrested?</ControlLabel>
                        <Switch
                            onText = "YES"
                            offText = "NO"
                            defaultValue={false}
                            value = {this.state.police_arrested}
                            onChange={(el, state)=>{
                                        var fakeEvent = {target: { id: "police_arrested", value: state}};
                                        this.handleChange(fakeEvent, state, null, fakeEvent.target.id, null)}
                                      }
                            name='police_arrested'
                        />
                    </FormGroup>

                    <div className="spacer"></div>

                    <FormGroup controlId="names_of_arrested" bsSize="sm">
                        <ControlLabel className="login_label">Name of Arrested</ControlLabel>
                        <FormControl
                            disabled={!this.state.police_arrested}
                            type="text"
                            key="names_of_arrested"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "names_of_arrested", null)}
                                      }
                            value={this.state.names_of_arrested}
                        />
                    </FormGroup>

                    <FormGroup controlId="charges" bsSize="sm">
                        <ControlLabel className="login_label">Charges?</ControlLabel>
                        <FormControl
                            type="text"
                            key="charges"
                            disabled={!this.state.police_arrested}
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "charges", null)}
                                      }
                            value={this.state.charges}
                        />
                    </FormGroup>

                    <FormGroup controlId="arrest_details" bsSize="sm">
                        <ControlLabel className="login_label">Arrest Details</ControlLabel>
                        <FormControl
                            disabled={!this.state.police_arrested}
                            key="arrest_details"
                            componentClass="textarea"
                            rows={4}
                            placeholder="Additional observations or comments..."
                            onChange={this.handleChange}
                            value={this.state.arrest_details}
                        />
                    </FormGroup>

                    {
                    //   <FormGroup controlId="police_disposition" bsSize="sm">
                    //     <ControlLabel className="login_label">Disposition</ControlLabel>
                    //     <FormControl  componentClass="select" placeholder="Use Dropdown"
                    //         key="police_disposition"
                    //         style={{width: "100%"}}
                    //         value={this.state.police_disposition}
                    //         onChange={(e)=>{this.setState({police_disposition: e.target.value})}}>
                    //             {hasFacilityLocations ? <option value={"select"}>Select Disposition</option> : null}
                    //             {hasFacilityLocations
                    //                 ? facility_locations.map((location) => {
                    //                     return <option key={location.facility_location_id} value={location.facility_location_id}>{location.location_name}</option>
                    //                     })
                    //                 : <option disabled value="select">No Dispositions Available</option>
                    //             }
                    //     </FormControl>
                    // </FormGroup>
                  }
                </div>

                <div className="right-side-content">
                  {this.renderWitnesses(this.state.witnesses)}

                  <FormGroup controlId="police_medical_condition" bsSize="sm">
                      <ControlLabel className="login_label">If witness knows patron, any awareness of medical condition/physical impairment that may be related to this incident?</ControlLabel>
                      <FormControl
                          type="text"
                          key="police_medical_condition"
                          onChange={(e)=>{
                                      this.handleChange(e, e.target.value, null, "police_medical_condition", null)}
                                    }
                          value={this.state.police_medical_condition}
                      />
                  </FormGroup>

                  {this.renderStaffWitnesses(this.state.staffWitnesses)}
                </div>


            </div>
        )
    }

    renderRefusalSection(){

        let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var month = months[this.state.date_added.getMonth()];
        var refusal_date = month + " " + this.state.date_added.getDate() + ", " + this.state.date_added.getFullYear();

        this.refusal_individual_name = this.state.refusal_individual_name ? this.state.refusal_individual_name : (this.state.individuals_data[0].name ? this.state.individuals_data[0].name : "");

        this.props.facilities.map((facility) => {
            if(facility.facility_id == this.state.facility_id) this.refusal_facility_location = facility.facility_name;
        })

        this.refusal_injured_parts_details = "Injured Body Part(s): ";

        if (this.state.injured_body){
            this.state.injured_body.map((item)=>{
                this.refusal_injured_parts_details += item + ', ';
            })
        }

        this.refusal_injured_parts_details += "\nLeft Side: ";

        if (this.state.injured_left){
            this.state.injured_left.map((item)=>{
                this.refusal_injured_parts_details += item + ', ';
            })
        }

        this.refusal_injured_parts_details += "\nRight Side: ";

        if (this.state.injured_right){
            this.state.injured_right.map((item)=>{
                this.refusal_injured_parts_details += item + ', ';
            })
        }

        return (
            <div className="incident-section">
                <h3 className="sub-title">Refusal</h3>
                <hr className="line"/>

                <p className="warning-paragraph">REFUSAL OF MEDICAL TREATMENT OR OBSERVATION FORM</p>

                <div className="left-side-content">
                    <h3 className="div-header">Individual Information</h3>
                    <hr className="line"/>

                    <FormGroup controlId="refusal_individual_name" bsSize="sm">
                        <ControlLabel className="login_label">Name</ControlLabel>
                        <FormControl
                            type="text"
                            key="refusal_individual_name"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "refusal_individual_name", null)}
                                      }
                            value={this.refusal_individual_name}
                        />
                    </FormGroup>

                    <FormGroup controlId="refusal_witnesses" bsSize="sm">
                        <ControlLabel className="login_label">Witness(es)</ControlLabel>
                        <FormControl
                            type="text"
                            key="refusal_witnesses"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "refusal_witnesses", null)}
                                      }
                            value={this.state.refusal_witnesses}
                        />
                    </FormGroup>

                    <FormGroup controlId="refusal_condition" bsSize="sm">
                        <ControlLabel className="login_label">Nature of Injury/Condition</ControlLabel>
                        <FormControl
                            key="refusal_condition"
                            componentClass="textarea"
                            rows={4}
                            placeholder=""
                            onChange={(e)=>{
                                this.handleChange(e, e.target.value, null, "refusal_condition", null)}
                            }
                            value={this.state.refusal_condition}
                        />
                    </FormGroup>

                    <FormGroup controlId="refusal_injured_parts_details" bsSize="sm">
                        <ControlLabel className="login_label">Description of Injury [Body Part(s) Injured]</ControlLabel>
                        <FormControl
                            key="refusal_injured_parts_details"
                            componentClass="textarea"
                            rows={4}
                            placeholder=""
                            onChange={(e)=>{
                                this.handleChange(e, e.target.value, null, "refusal_injured_parts_details", null)}
                            }
                            value={this.refusal_injured_parts_details}
                        />
                    </FormGroup>

                    <FormGroup controlId="refusal_incident_details" bsSize="sm">
                        <ControlLabel className="login_label">Brief Narrative Description of the Incident</ControlLabel>
                        <FormControl
                            key="refusal_incident_details"
                            componentClass="textarea"
                            rows={4}
                            placeholder=""
                            onChange={(e)=>{
                                this.handleChange(e, e.target.value, null, "refusal_incident_details", null)}
                            }
                            value={this.state.refusal_incident_details}
                        />
                    </FormGroup>

                </div>

                <div className="right-side-content">

                    <h3 className="div-header">Signature </h3>
                    <hr className="line"/>

                    <p className="paragraph">I,
                        <FormControl
                            style={{width: 200}}
                            className="paragraph-input form-control-sm"
                            type="text"
                            key="refusal_individual_name"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "refusal_individual_name", null)}
                                      }
                            value={this.refusal_individual_name}
                        />
                    , hereby acknowledge my refusal of medical treatment and/or observation offered to me for the injury I incurred on

                        <FormControl
                                style={{width: 130}}
                                className="paragraph-input form-control-sm"
                                type="text"
                                key="refusal_date"
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, null, "refusal_date", null)}
                                        }
                                value={refusal_date}
                        />

                        at

                        <FormControl
                                style={{width: 150}}
                                className="paragraph-input form-control-sm"
                                type="text"
                                key="refusal_facility_location"
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, null, "refusal_facility_location", null)}
                                        }
                                value={this.state.refusal_facility_location || this.refusal_facility_location}
                        />

                    either as provided for my employees of Live Nation Entertainment, Inc. on behalf of itself and its parents, subsidiaries, and affiliated companies (collectively, "Live Nation") or as provided by a service directly contracted by Live Nation.
                    Additionally, I have instructed Live Nation not to dispatch ambulatory or other medical services external to and unaffiliated with Live Nation.</p>

                    <p className="paragraph">By signing this document, I acknowledge that I am aware of the potential benefits of medical treatment and the risks associated with refusing such treatment, which I fully understand. In spite of this understanding, I refuse to consent to medical treatment.</p>

                    <FormGroup controlId="refusal_individual_name" bsSize="sm" style={{marginTop: 20}}>
                        <ControlLabel className="login_label">Name</ControlLabel>
                        <FormControl
                            type="text"
                            key="refusal_individual_name"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "refusal_individual_name", null)}
                                      }
                            value={this.refusal_individual_name}
                        />
                    </FormGroup>

                    <FormGroup controlId="refusal_signature" bsSize="sm">
                        <ControlLabel className="login_label">Signature</ControlLabel>
                        <FormControl
                            type="text"
                            key="refusal_signature"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "refusal_signature", null)}
                                      }
                            value={this.state.refusal_signature}
                        />
                    </FormGroup>

                    <FormGroup controlId="refusal_parent_signature" bsSize="sm">
                        <ControlLabel className="login_label">Parent's/Guardian's Signature (If individual is a minor)</ControlLabel>
                        <FormControl
                            type="text"
                            key="refusal_parent_signature"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "refusal_parent_signature", null)}
                                      }
                            value={this.state.refusal_parent_signature}
                        />
                    </FormGroup>

                    <FormGroup controlId="refusal_date" bsSize="sm">
                        <ControlLabel className="login_label">Date</ControlLabel>
                        <FormControl
                            type="text"
                            key="refusal_date"
                            onChange={(e)=>{
                                        this.handleChange(e, e.target.value, null, "refusal_date", null)}
                                      }
                            value={refusal_date}
                        />
                    </FormGroup>
                </div>


            </div>
        )
    }

    renderWitnesses(witnesses) {

      const type = "witness";
      const rows = [];
      witnesses = witnesses ? witnesses : [];

      witnesses.map((witness, index)=>{
        rows.push(<div key={"witness_"+index}>
                      <h3 className="div-header">Witness # {index+1}</h3>
                      <hr className="line"/>
                      {/* <div className="spacer"></div> */}

                      <FormGroup controlId="name" bsSize="sm">
                          <ControlLabel className="login_label">Witness Name</ControlLabel>
                          <FormControl
                              key={"name_"+index}
                              type="text"
                              onChange={(e)=>{
                                          this.handleChange(e, e.target.value, type, "name", index)}
                                        }
                              value={witness.name}
                          />
                      </FormGroup>

                      <FormGroup controlId="phone" bsSize="sm">
                          <ControlLabel className="login_label">Phone</ControlLabel>
                          <FormControl
                              key="phone"
                              type="text"
                              onChange={(e)=>{
                                          this.handleChange(e, e.target.value, type, "phone", index)}
                                        }
                              value={witness.phone}
                          />
                      </FormGroup>

                      <FormGroup controlId="relationship" bsSize="sm">
                          <ControlLabel className="login_label">Relationship</ControlLabel>
                          <FormControl
                              type="text"
                              key="relationship"
                              onChange={(e)=>{
                                          this.handleChange(e, e.target.value, type, "relationship", index)}
                                        }
                              value={witness.relationship}
                          />
                      </FormGroup>

                      <FormGroup controlId="address" bsSize="sm">
                          <ControlLabel className="login_label">Address</ControlLabel>
                          <FormControl
                              type="text"
                              key="address"
                              onChange={(e)=>{
                                          this.handleChange(e, e.target.value, type, "address", index)}
                                        }
                              value={witness.address}
                          />
                      </FormGroup>

                      <FormGroup controlId="description" bsSize="sm">
                          <ControlLabel className="login_label">Witness description of incident</ControlLabel>
                          <FormControl
                              key="description"
                              componentClass="textarea"
                              rows={4}
                              placeholder="Enter witness description..."
                              onChange={(e)=>{
                                          this.handleChange(e, e.target.value, type, "description", index)}
                                        }
                              value={witness.description}
                          />
                      </FormGroup>
                </div>);
      })

      return rows;

    }

    renderStaffWitnesses(witnesses) {
      const type = "staffWitness";
      const rows = [];

      witnesses = witnesses ? witnesses : [];
      witnesses.map((witness, index) => {

        rows.push(<FormGroup key={"staffWitness_"+index} controlId="detail" bsSize="sm">
                    <ControlLabel className="login_label">Venue Staff Witness #{index + 1}</ControlLabel>
                    <FormControl
                        key="detail"
                        type="text"
                        onChange={(e)=>{
                                    this.handleChange(e, e.target.value, type, "detail", index)}
                                  }
                        value={witness.detail}
                    />
                </FormGroup>)
      });

      return rows;
    }

    renderIndividual(individual_data, index) {
        let hasFacilityLocations = this.props.facility_locations ? true : false;
        let hasFacilities = this.props.facilities ? true : false;

        let facility_locations = this.props.facility_locations;
        let facilities = this.props.facilities;
        let type = "individual";
        return (
            <React.Fragment key={index}>
                <Row style={{padding:'20px 10pxd'}}>
                    <Col md={6}>
                        <FormGroup controlId="name" bsSize="sm">
                            <ControlLabel className="login_label">Individual Name</ControlLabel>
                            <FormControl
                                type="text"
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, type, "name", index)}
                                          }
                                value={individual_data.name ? individual_data.name : ""}
                            />
                        </FormGroup>
                        <FormGroup controlId="address" bsSize="sm">
                            <ControlLabel className="login_label">Address</ControlLabel>
                            <FormControl
                                type="text"
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, type, "address", index)}
                                          }
                                value={individual_data.address ? individual_data.address : ""}
                            />
                        </FormGroup>

                        <div className="half-width" style={{float: 'left', paddingRight: 15}}>
                            <FormGroup controlId="birthday" bsSize="sm">
                                <ControlLabel className="form-label">Birthday </ControlLabel>
                                <DatePicker
                                    id={"birthday"}
                                    onChange={(e)=> {
                                    var fakeEvent = {target: { id: "birthday", value: e}};
                                        this.handleChange(fakeEvent, e, type, "birthday", index);
                                    }}
                                    value={individual_data.birthday != "Invalid Date" ? individual_data.birthday : null}
                                    dateFormat={"MM-DD-YYYY"}
                                    maxDate={new Date().toISOString()}
                                    className="form-control"
                                    calendarClassName={"pickerCalendar"}
                                    calendarIcon={null}
                                    clearIcon={null}
                                />
                            </FormGroup>

                            <FormGroup controlId="height" bsSize="sm">
                                <ControlLabel className="login_label">Height </ControlLabel>
                                <FormControl
                                    type="text"
                                    onChange={(e)=>{
                                                this.handleChange(e, e.target.value, type, "height", index)}
                                              }
                                    value={individual_data.height}
                                />
                            </FormGroup>

                            <FormGroup controlId="hair" bsSize="sm">
                                <ControlLabel className="login_label">Hair Color </ControlLabel>
                                <FormControl
                                    type="text"
                                    onChange={(e)=>{
                                                this.handleChange(e, e.target.value, type, "hair", index)}
                                              }
                                    value={individual_data.hair}
                                />
                            </FormGroup>

                            <FormGroup controlId="employer" bsSize="sm">
                                <ControlLabel className="login_label">Employer </ControlLabel>
                                <FormControl
                                    type="text"
                                    onChange={(e)=>{
                                                this.handleChange(e, e.target.value, type, "employer", index)}
                                              }
                                    value={individual_data.employer}
                                />
                            </FormGroup>
                        </div>

                        <div className="half-width" style={{float: 'right'}}>
                            <FormGroup controlId="expiration" bsSize="sm">
                                <ControlLabel className="form-label">ID Expiration Date </ControlLabel>
                                <DatePicker
                                    id={"expiration"}
                                    onChange={(e)=> {
                                    var fakeEvent = {target: { id: "expiration", value: e}};
                                        this.handleChange(fakeEvent, e, type, "expiration", index);
                                    }}
                                    value={individual_data.expiration != "Invalid Date" ? individual_data.expiration : null}
                                    dateFormat={"MM-DD-YYYY"}
                                    className="form-control"
                                    calendarClassName={"pickerCalendar"}
                                    calendarIcon={null}
                                    clearIcon={null}
                                />
                            </FormGroup>
                            <FormGroup controlId="weight" bsSize="sm">
                                <ControlLabel className="login_label">Weight </ControlLabel>
                                <FormControl
                                    type="text"
                                    onChange={(e)=>{
                                                this.handleChange(e, e.target.value, type, "weight", index)}
                                              }
                                    value={individual_data.weight}
                                />
                            </FormGroup>

                            <FormGroup controlId="eye" bsSize="sm">
                                <ControlLabel className="login_label">Eye Color </ControlLabel>
                                <FormControl
                                    type="text"
                                    onChange={(e)=>{
                                                this.handleChange(e, e.target.value, type, "eye", index)}
                                              }
                                    value={individual_data.eye}
                                />
                            </FormGroup>

                            <FormGroup controlId="work_phone" bsSize="sm">
                                <ControlLabel className="login_label">Work Phone</ControlLabel>
                                <FormControl
                                    type="text"
                                    onChange={(e)=>{
                                                this.handleChange(e, e.target.value, type, "work_phone", index)}
                                              }
                                    value={individual_data.work_phone}
                                />
                            </FormGroup>
                        </div>

                      {
                        // <FormGroup controlId="guest_disposition" bsSize="sm">
                        //     <ControlLabel className="login_label">Disposition</ControlLabel>
                        //     <FormControl  componentClass="select" placeholder="Use Dropdown"
                        //     style={{width: "100%"}}
                        //     value={this.state.guest_disposition}
                        //     onChange={(e)=>{this.setState({guest_disposition: e.target.value})}}>
                        //             {hasFacilityLocations ? <option value={"select"}>Select Disposition</option> : null}
                        //             {hasFacilityLocations
                        //                 ? facility_locations.map((location) => {
                        //                     return <option key={location.facility_location_id} value={location.facility_location_id}>{location.location_name}</option>
                        //                     })
                        //                 : <option disabled value="select">No Dispositions Available</option>
                        //             }
                        //     </FormControl>
                        // </FormGroup>
                      }
                        <FormGroup controlId="how_incident" bsSize="sm">
                            <ControlLabel className="login_label">How did the incident occur?</ControlLabel>
                            <FormControl
                                componentClass="textarea"
                                rows={4}
                                placeholder="Enter the narrative from the individual details..."
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, type, "how_incident", index)}
                                          }
                                value={individual_data.how_incident}
                            />
                        </FormGroup>

                        <div className="half-width">
                            <ControlLabel className="left-form-label">When did you arrive at the venue?</ControlLabel>
                            <CustomTimePicker id='arrival_time'
                                        onChange={(e)=>{
                                                    var fakeEvent = {target: { id: "arrival_time", value: e}};
                                                    this.handleChange(fakeEvent, e, type, fakeEvent.target.id, index)}
                                                  }  />
                        </div>

                        <FormGroup controlId="guest_eat_arrival">
                            <ControlLabel className="left-form-label">Did you eat prior to arrival?</ControlLabel>
                            <Switch
                                onText = "YES"
                                offText = "NO"
                                defaultValue={false}
                                value = {individual_data.guest_eat_arrival}
                                onChange={(el, state)=>{
                                            var fakeEvent = {target: { id: "guest_eat_arrival", value: state}};
                                            this.handleChange(fakeEvent, state, type, fakeEvent.target.id, index)}
                                          }
                                name='guest_eat_arrival'
                            />
                        </FormGroup>

                        <div className="spacer"></div>

                        {
                          // <FormGroup controlId="guest_foods" bsSize="sm">
                          //   <ControlLabel className="login_label">What foods?</ControlLabel>
                          //   <FormControl
                          //       type="text"
                          //       onChange={this.handleChange}
                          //       value={this.state.guest_foods}
                          //   />
                          // </FormGroup>
                      }
                        <div className="half-width" style={{float: 'left', paddingRight: 15}} >
                            <ControlLabel className="left-form-label">What time did you eat?</ControlLabel>
                            {/* <CustomTimePicker id='time_eat_arrival'
                                        disabled={!individual_data.guest_eat_arrival}
                                        onChange={(e)=>{
                                                    var fakeEvent = {target: { id: "time_eat_arrival", value: e}};
                                                    this.handleChange(fakeEvent, e, type, fakeEvent.target.id, index)}
                                                  }/> */}
                            <FormControl
                                disabled={!individual_data.guest_eat_arrival}
                                id="time_eat_arrival"
                                type="text"
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, type, "time_eat_arrival", index)}
                                          }
                                value={individual_data.time_eat_arrival}
                            />
                        </div>

                        <div className="half-width" style={{float: 'right'}}>

                            <ControlLabel className="login_label">What did you eat? </ControlLabel>
                            <FormControl
                                disabled={!individual_data.guest_eat_arrival}
                                id="food_eat_prior_to_arrival"
                                type="text"
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, type, "food_eat_prior_to_arrival", index)}
                                          }
                                value={individual_data.food_eat_prior_to_arrival}
                            />
                        </div>


                        <FormGroup controlId="guest_eat_venue">
                            <ControlLabel className="left-form-label">Did you eat at this venue?</ControlLabel>
                            <Switch
                                onText = "YES"
                                offText = "NO"
                                defaultValue={false}
                                value = {individual_data.guest_eat_venue}
                                onChange={(el, state)=>{
                                            var fakeEvent = {target: { id: "guest_eat_venue", value: state}};
                                            this.handleChange(fakeEvent, state, type, fakeEvent.target.id, index)}
                                          }
                                name='guest_eat_venue'
                            />
                        </FormGroup>

                        <div className="spacer"></div>
                        {
                          // <FormGroup controlId="guest_foods_at_venue" bsSize="sm">
                          //     <ControlLabel className="login_label">What foods?</ControlLabel>
                          //     <FormControl
                          //         type="text"
                          //         onChange={this.handleChange}
                          //         value={this.state.guest_foods_at_venue}
                          //     />
                          // </FormGroup>
                        }
                        <div className="half-width" style={{float: 'left', paddingRight: 15}}>
                            <ControlLabel className="left-form-label">What time did you eat?</ControlLabel>
                            {/* <CustomTimePicker id='time_eat_venue'
                                      disabled={!individual_data.guest_eat_venue}
                                      onChange={(e)=>{
                                                    var fakeEvent = {target: { id: "time_eat_venue", value: e}};
                                                  this.handleChange(fakeEvent, e, type, "time_eat_venue", index)}
                                                }/> */}
                            <FormControl
                                disabled={!individual_data.guest_eat_venue}
                                id="time_eat_venue"
                                type="text"
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, type, "time_eat_venue", index)}
                                          }
                                value={individual_data.time_eat_venue}
                            />
                        </div>

                        <div className="half-width" style={{float: 'right'}}>

                            <ControlLabel className="login_label">What did you eat? </ControlLabel>
                            <FormControl
                                disabled={!individual_data.guest_eat_venue}
                                id="food_eat_venue"
                                type="text"
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, type, "food_eat_venue", index)}
                                          }
                                value={individual_data.food_eat_venue}
                            />
                        </div>

                        <FormGroup controlId="similar_food_complaints">
                            <ControlLabel className="left-form-label">Were there other similar food complaints on this date?</ControlLabel>
                            <Switch
                                onText = "YES"
                                offText = "NO"
                                defaultValue={false}
                                value = {individual_data.similar_food_complaints}

                                onChange={(el, state)=>{
                                            var fakeEvent = {target: { id: "similar_food_complaints", value: state}};
                                            this.handleChange(fakeEvent, state, type, fakeEvent.target.id, index)}
                                          }
                                name='similar_food_complaints'
                            />
                        </FormGroup>

                        {/* <div className="spacer"></div>

                        <Button className="green-btn" onClick={this.handleNextButton}>Add Person Manually</Button>
                        <Button className="gray-btn" onClick={this.handleNextButton}>Repeat Offender</Button> */}
                    </Col>

                    <Col md={6}>

                      {
                        // <FormGroup controlId="prior_alcohol_consumption">
                        //     <ControlLabel className="left-form-label">Did you consume alcohol before coming to venue?</ControlLabel>
                        //     <Switch
                        //         onText = "YES"
                        //         offText = "NO"
                        //         value = {this.state.prior_alcohol_consumption}
                        //         onChange={(el, state) => this.handleSwitch(el, state)}
                        //         name='prior_alcohol_consumption'
                        //     />
                        // </FormGroup>
                        //
                        // <div className="spacer"></div>
                        //
                        // <FormGroup controlId="prior_alcohol_kind" bsSize="sm">
                        //     <ControlLabel className="login_label">What kind?</ControlLabel>
                        //     <FormControl
                        //         type="text"
                        //         onChange={this.handleChange}
                        //         value={this.state.prior_alcohol_kind}
                        //     />
                        // </FormGroup>
                        // <FormGroup controlId="prior_alcohol_quantity" bsSize="sm">
                        //     <ControlLabel className="login_label">How much?</ControlLabel>
                        //     <FormControl
                        //         type="text"
                        //         onChange={this.handleChange}
                        //         value={this.state.prior_alcohol_quantity}
                        //     />
                        // </FormGroup>

                      }
                        {/*  */}

                        <FormGroup controlId="consume_alcohol">
                            <ControlLabel className="left-form-label">Did you consume alcohol at this venue?</ControlLabel>
                            <Switch
                                onText = "YES"
                                offText = "NO"
                                defaultValue={false}
                                value = {individual_data.consume_alcohol}
                                onChange={(el, state)=>{
                                            var fakeEvent = {target: { id: "consume_alcohol", value: state}};
                                            this.handleChange(fakeEvent, state, type, fakeEvent.target.id, index)}
                                          }
                                name='consume_alcohol'
                            />
                        </FormGroup>

                        <div className="spacer"></div>

                        <FormGroup controlId="kind_of_alcohol" bsSize="sm">
                            <ControlLabel className="login_label">What kind?</ControlLabel>
                            <FormControl
                                type="text"
                                disabled={!individual_data.consume_alcohol}
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, type, "kind_of_alcohol", index)}
                                          }
                                value={individual_data.kind_of_alcohol}
                            />
                        </FormGroup>
                        <FormGroup controlId="how_much_alcohol" bsSize="sm">
                            <ControlLabel className="login_label">How much?</ControlLabel>
                            <FormControl
                                type="text"
                                disabled={!individual_data.consume_alcohol}
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, type, "how_much_alcohol", index)}
                                          }
                                value={individual_data.how_much_alcohol}
                            />
                        </FormGroup>

                        {/*  */}

                        <FormGroup controlId="paid_with">
                            <ControlLabel className="left-form-label">Paid with?</ControlLabel>
                            <Switch
                                onText = "Cash"
                                offText = "Credit"
                                defaultValue={false}
                                value = {individual_data.paid_with ? individual_data.paid_with : false}
                                onChange={(el, state)=>{
                                            var fakeEvent = {target: { id: "paid_with", value: state}};
                                            this.handleChange(fakeEvent, state, type, fakeEvent.target.id, index)}
                                          }
                                name='paid_with'
                            />
                        </FormGroup>

                        <div className="spacer"></div>

                        <FormGroup controlId="card_type" bsSize="sm">
                            <ControlLabel className="login_label">Card Type/Name</ControlLabel>
                            <FormControl
                                type="text"
                                disabled={individual_data.paid_with}
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, type, "card_type", index)}
                                          }
                                value={individual_data.card_type}
                            />
                        </FormGroup>

                        <FormGroup controlId="bartender_description" bsSize="sm">
                            <ControlLabel className="login_label">Guest Description of bartender/server</ControlLabel>
                            <FormControl
                                componentClass="textarea"
                                rows={4}
                                placeholder="Enter bartender description..."
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, type, "bartender_description", index)}
                                          }
                                value={individual_data.bartender_description}
                            />
                        </FormGroup>

                        <div className="spacer"></div>

                        <FormGroup controlId="guest_witness" bsSize="sm">
                            <ControlLabel className="login_label">Guest's Designated Witness</ControlLabel>
                            <FormControl
                                type="text"
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, type, "guest_witness", index)}
                                          }
                                value={individual_data.guest_witness}
                            />
                        </FormGroup>
                        <FormGroup controlId="guest_medical_condition" bsSize="sm">
                            <ControlLabel className="login_label">Guest's medical condition / physical impairment that may be related to this accident?</ControlLabel>
                            <FormControl
                                componentClass="textarea"
                                rows={4}
                                placeholder="Enter guest's health details..."
                                onChange={(e)=>{
                                            this.handleChange(e, e.target.value, type, "guest_medical_condition", index)}
                                          }
                                value={individual_data.guest_medical_condition}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    renderButtons(position){
        const {tab} = this.state;
        var tabNames = {
            guest: "Guest",
            incident: "Incident Info",
            property: "Property",
            medical: "Medical",
            police: "Police",
            refusal: "Refusal",
            sign: "Sign"
        }

        var pageCount = 0;
        if(position === "top") {
          return (
              <div className="footer-section">
                  <ButtonGroup aria-label="Basic example">
                    <Button disabled={tab === 'incident'} style={{backgroundColor: "#67BBEE", color: "white", height: "40px", width: "180px", padding: "10px", fontSize: 14, fontWeight: "bold", marginRight: 15}}
                            onClick={this.handlePrevButton}>Previous Section</Button>
                    <Button style={{backgroundColor: "#ed4747", color: "white", height: "40px", width: "180px", padding: "10px", fontSize: 14, fontWeight: "bold", marginRight: 15}}
                            onClick={this.resetValues}>Clear</Button>
                    <Button style={{backgroundColor: "#00C491", color: "white", height: "40px", width: "180px", padding: "10px", fontSize: 14, fontWeight: "bold", marginRight: 15}}
                            onClick={this.handleSubmitIncident}>{this.props.itemToEdit ? "Save" : "Submit"} Report</Button>
                    <Button disabled={tab === 'sign'} style={{backgroundColor: "#67BBEE", color: "white", height: "40px", width: "180px", padding: "10px", fontSize: 14, fontWeight: "bold"}}
                            onClick={this.handleNextButton}>Next Section</Button>
                  </ButtonGroup>

                  <Row style={{marginBottom: 20, marginTop: 20}}>
                    <ButtonGroup aria-label="Basic example">
                    {Object.keys(tabNames).map((tabName)=>{
                      if(this.state.tabs[tabName]) {
                        pageCount++;
                        return this.renderTracker(pageCount, tabNames[tabName], tabName);
                      }
                    })}
                    </ButtonGroup>
                  </Row>

                  <hr className="line"/>
              </div>
          )
        } else {

          return (
              <div className="footer-section">
                  <hr className="line"/>
                  <Row style={{marginBottom: 20}}>
                    <ButtonGroup aria-label="Basic example">
                    {Object.keys(tabNames).map((tabName)=>{
                      if(this.state.tabs[tabName]) {
                        pageCount++;
                        return this.renderTracker(pageCount, tabNames[tabName], tabName);
                      }
                    })}
                    </ButtonGroup>
                  </Row>
                  <ButtonGroup aria-label="Basic example">
                    <Button disabled={tab === 'incident'} style={{backgroundColor: "#67BBEE", color: "white", height: "40px", width: "180px", padding: "10px", fontSize: 14, fontWeight: "bold", marginRight: 15}}
                            onClick={this.handlePrevButton}>Previous Section</Button>
                    <Button style={{backgroundColor: "#ed4747", color: "white", height: "40px", width: "180px", padding: "10px", fontSize: 14, fontWeight: "bold", marginRight: 15}}
                            onClick={this.resetValues}>Clear</Button>
                    <Button style={{backgroundColor: "#00C491", color: "white", height: "40px", width: "180px", padding: "10px", fontSize: 14, fontWeight: "bold", marginRight: 15}}
                            onClick={this.handleSubmitIncident}>{this.props.itemToEdit ? "Save" : "Submit"} Report</Button>
                    <Button disabled={tab === 'sign'} style={{backgroundColor: "#67BBEE", color: "white", height: "40px", width: "180px", padding: "10px", fontSize: 14, fontWeight: "bold", marginRight: 15}}
                            onClick={this.handleNextButton}>Next Section</Button>
                  </ButtonGroup>
              </div>
          )

        }


    }

    renderTracker(page, title, tab) {
      var backgroundColor = tab === this.state.tab ? "#EC6445" : "#67BBEE";
      var color = tab === this.state.tab ? "white" : "white";//"black";
      return <Button key={page} style={{backgroundColor: backgroundColor, color: color, height: "50px", width: "55px", padding: "2px", fontSize: 14, fontWeight: "bold", marginRight: 10}}
              onClick={()=>{
                this.setState({
                  tab: tab
                })
              }}>
                <div style={{fontSize: 14, fontWeight: "bold", color: color}}>{page}</div>
                <div style={{fontSize: 9, color: color, textWrap: ""}}>{title}</div>
              </Button>
    }

    renderIncidentTitle = (cell, row, rowIndex, formatExtraData) => {

            return(
                <div>
                    <Form>
                        <FormGroup>
                          <Checkbox id="active"
                              defaultChecked={false}
                              disabled
                              checked={this.state.linked_files.indexOf(row) >= 0}>{row.title}</Checkbox>
                        </FormGroup>
                    </Form>
                </div>

            )

    }

    renderDateAdded = (cell, row, rowIndex, formatExtraData) => {

        Date.prototype.formattedTime = function(){
            var h = this.getHours();
            var m = this.getMinutes();
            var ampm = h<12 && m <= 59 ? "AM" : "PM";
            h = h>12 ? h-12 : (h == 0 ? 12 : h);
            m = m<10 ? ('0'+m) : m;

            return h+':'+m+' '+ampm;
        }

        var archive_date = new Date(cell);
        var date = (archive_date.getMonth()+1) + "/" + archive_date.getDate() + "/" + archive_date.getFullYear();
        var time = archive_date.formattedTime();

        return (
            <h5> {date} {`\n`} @ {time} </h5>
        )
    }

    renderActions = (cell, row, rowIndex, formatExtraData) => {
        var classStyle = "";
        switch (row.status){
            case "Completed":
                classStyle = "status-completed";
                break;
            case "Needs Attention":
                classStyle = "status-failed";
                break;
            case "In Progress":
                classStyle = "status-in-progress";
                break;
            default:
                break;
        }
        return(
            <div className="action-items">
                <div>
                    <h5 className={classStyle}>{row.status}</h5>
                </div>
            </div>
        )
    }

  /*  renderLinkModal() {

      return  (<Modal style={{marginTop: "10%"}}
                      show={this.state.showLinkModal}
                      onExit={()=>{ console.log("MEOW");}}>
                      <Modal.Header>
                        <b style={{fontSize: 20}}>Link Files</b>
                      </Modal.Header>
                      <Modal.Body>
                        <BootstrapTable width="100%" data={ this.props.tableData ? this.props.tableData.rows : [] } hover={true} keyField="id" search={true} pagination options={this.options} trClassName={"usersRow"}>
                            <TableHeaderColumn dataField='title' width="15%" dataSort dataFormat={this.renderIncidentTitle}>Incident Title</TableHeaderColumn>
                            <TableHeaderColumn dataField='type' width="10%" dataSort>Type</TableHeaderColumn>
                            <TableHeaderColumn dataField='facility' width="10%" dataSort>Facility</TableHeaderColumn>
                            <TableHeaderColumn dataField='time' width="10%" dataSort dataFormat={this.renderDateAdded}>Time Sent</TableHeaderColumn>
                            <TableHeaderColumn dataField='staff' width="10%" dataSort>Staff</TableHeaderColumn>
                            <TableHeaderColumn dataField='status' width="10%" dataSort dataFormat={this.renderActions}>Status</TableHeaderColumn>
                        </BootstrapTable>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button bsStyle="danger" onClick={()=>{this.setState({showLinkModal: false})}}>Close</Button>
                      </Modal.Footer>
             </Modal>)
    }*/

    renderLinkModal() {


        return  (<Modal style={{marginTop: "10%"}}
                        show={this.state.showLinkModal}
                        onExit={()=>{}}>
                        <Modal.Header>
                          <b style={{fontSize: 20}}>Link Files</b>
                        </Modal.Header>
                        <Modal.Body>
                          <BootstrapTable width="100%" data={ this.props.tableData ? this.props.tableData.rows : [] } hover={true} keyField="id" search={true} pagination options={this.linkIncidentOptions} trClassName={"usersRow"}>
                              <TableHeaderColumn dataField='time' width="10%" dataSort dataFormat={this.renderLinkIncidentDate}>Date</TableHeaderColumn>
                              <TableHeaderColumn dataField='facility' width="10%" dataSort>Venue</TableHeaderColumn>
                              <TableHeaderColumn dataField='location' width="15%">Location</TableHeaderColumn>
                              <TableHeaderColumn width="10%" dataFormat={this.renderLinkIncidentAction} formatExtraData={{allLinkedFiles: this.state.linked_files}}>Action</TableHeaderColumn>
                          </BootstrapTable>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button bsStyle="danger" onClick={()=>{this.setState({showLinkModal: false})}}>Close</Button>
                        </Modal.Footer>
               </Modal>)

    }

    renderLinkIncidentAction(cell, row, formatExtraData) {
      var linkedFiles = formatExtraData.allLinkedFiles;
      var fileExists = _.find(linkedFiles, (linkedFile)=>{
        return linkedFile.id === row.id
      })

      if(fileExists) {
        return (<div>
                  <Button onClick={()=>{this.handleLinkFile(row)}}>Unlink</Button>
                </div>);
      } else {
        return (<div>
                  <Button onClick={()=>{ this.handleLinkFile(row)}}>Link</Button>
                </div>);
      }

    }

    renderLinkIncidentDate(cell, row, rowIndex, formatExtraData) {
        return (<div>
                  {moment(row.time).format("MM-DD-YYYY")}
                </div>)
    }

    // Action Handlers

    handleAddEmail() {
      ToastStore.warning( "Adding more Emails in progress!");
    }

    handleLinkFile(incident) {
      var newLinkedFiles = this.state.linked_files ? this.state.linked_files.slice() : [];

      if(newLinkedFiles.includes(incident)) {
        newLinkedFiles.splice(newLinkedFiles.indexOf(incident), 1);
      } else {
        newLinkedFiles.push(incident);
      }

      this.setState({
        linked_files: newLinkedFiles
      })
    }

    handleCheckBoxTick(e, group){
        //I added the group parameter for dealing with checkboxes
        //that are expected to make a list, like the Injuries fields. -Tere
        const {tabs} = this.state;
        const {name, value ,checked} = e.target;
        const checkBoxTabs = Object.keys(tabs);

        if(checkBoxTabs.indexOf(value) >= 0) {
            tabs[value] = checked;
        }


        let currentValue = this.state[name] == 'on' ? 'off' : 'on';
        //var newState = {[name] : value};
        var newState = {};
        //If group param is not null, add to a list of that checkbox's group.
        //We list these stuff in the PDF.
        if(group != null) {
          newState[group] = typeof(this.state[group]) != "undefined" ? this.state[group] : [];
          if(newState[group] != null) {
            if(newState[group].includes(name)) {

              if(name === "Accepted") {
                newState[group].splice(newState[group].indexOf("Accepted"), 1);
              } else if (name === "Declined") {
                newState[group].splice(newState[group].indexOf("Declined"), 1);
              } else {
                newState[group].splice(newState[group].indexOf(name), 1);
              }

            } else {
              if(group === "offsite_emergency_care") {
                if(name === "Accepted" && newState[group].indexOf("Declined") >= 0) {
                  newState[group].splice(newState[group].indexOf("Declined"), 1);
                } else if (name === "Declined" && newState[group].indexOf("Accepted") >= 0) {
                  newState[group].splice(newState[group].indexOf("Accepted"), 1);
                }
              }
              newState[group].push(name);
              newState.tabs = tabs;
            }
          } else {
            newState[group] = [];
            newState[group].push(name);
          }

        } else {
            newState[name] = currentValue;
        }
        this.setState(newState);
    }

    handleTimeIncidentChanged(time){
        this.setState({time_of_incident: time});
    }

    handleTimeSecurityArrivedChanged(time){
        this.setState({time_security_arrived: time});
    }

    handleTimePoliceArrivedChanged(time){
        this.setState({time_police_arrived: time});
    }

    handleTimeGuestArrivedChanged(time){
        this.setState({arrival_time: time});
    }

    handleTimeGuestAteChanged(time){
        this.setState({time_guest_ate: time});
    }

    handleTimeGuestAteAtVenueChanged(time){
        this.setState({time_eat_arrival: time});
    }

    handleSwitch(elem, state) {
        let name = elem.props.name;
        this.setState({[name]: state});
    }

    handleNextButton(){
        const {tab,tabs} = this.state;
        const tabKeys = Object.keys(tabs);
        const currKey = tabKeys.indexOf(tab);
        for(let x = (currKey + 1); x < (tabKeys).length; x++){
            const key = tabKeys[x];
            const show = tabs[key]

            if(key === "refusal") {
              show = tabs["refusal"] && tabs["medical"] && this.state.first_aid_accepted === "Declined";
            }
            if(show){
                return this.setState({ tab:key });
            }
        }
    }

    handlePrevButton(){
        const {tab,tabs} = this.state;
        const tabKeys = Object.keys(tabs);
        const currKey = tabKeys.indexOf(tab);

        for(let x = (currKey - 1); x >= 0; x--){
            const key = tabKeys[x];
            const show = tabs[key]

            if(key === "refusal") {
              show = tabs["refusal"] && tabs["medical"] && this.state.first_aid_accepted === "Declined";
            }

            if(show){
                return this.setState({ tab:key });
            }
        }
    }

    //index is for arrays, like Individuals. can be null
    handleChange(event , value, type, key, index) {
          if(event.target.id == "mobile_phone" || event.target.id == "work_phone") {
            value = value.replace(/\D/g, '');
          }
          var newState = {
              hasChanged: true,
          };

          switch(type) {
            case 'individual':
              var newIndividualsData = this.state.individuals_data;
              var newIndividualData = newIndividualsData[index];
              newIndividualData[key] = value;
              newIndividualsData.splice(index, 1, newIndividualData);
              newState["individuals_data"] = newIndividualsData;
            break;

            case 'witness':
              var newWitnesses = this.state.witnesses.slice();
              var newWitness = newWitnesses[index];

              newWitness[key] = value;
              newWitnesses.splice(index, 1, newWitnesses);
              //newState["witnesses"] = newWitnesses;
            break;

            case 'staffWitness':
              var newWitnesses = this.state.staffWitnesses.slice();
              var newWitness = newWitnesses[index];

              newWitness[key] = value;
              newWitnesses.splice(index, 1, newWitnesses);
              //newState["staffWitnesses"] = newWitnesses;
            break;

            default:
              newState[event.target.id] = value;
            break;
          }

          this.setState(newState);
    }

    handleSubmitIncident() {

        var newLinkedFiles = [];

        this.state.linked_files.map((linked_file)=>{
            let rawIncidentFile = "";
            if(linked_file){
                rawIncidentFile = _.find(this.props.incidents, (incident)=>{ return incident.id === linked_file.id});
                newLinkedFiles.push(rawIncidentFile);
            }
        })

        // Handle Refusal Form:
        var refusal_of_medical_treatment_form = {
            refusal_name: this.state.refusal_individual_name || this.refusal_individual_name,
            refusal_witnesses: this.state.refusal_witnesses || "",
            refusal_condition: this.state.refusal_condition || "",
            refusal_injury: this.state.refusal_injured_parts_details || this.refusal_injured_parts_details,
            refusal_incident_details: this.state.refusal_incident_details || "",
            refusal_date: this.state.refusal_date || this.state.date_added,
            refusal_venue: this.refusal_facility_location || this.refusal_facility_location,
            refusal_signature: this.state.refusal_parent_signature || "",
            refusal_parent_signature: this.state.refusal_parent_signature || "",
        }

        var other_form_data = {
                                address: this.state.address,
                                asset_damage: this.state.asset_damage,
                                damage_value: this.state.damage_value,
                                time_of_incident: this.state.time_of_incident,
                                time_security_arrived:this.state.time_security_arrived,
                                time_police_arrived: this.state.time_police_arrived,
                                tape_on_file: this.state.tape_on_file,
                                location_desc: this.state.location_desc,
                                occupancy: this.state.occupancy,
                                occupancy_other: this.state.occupancy_other,
                                lighting_club: this.state.lighting_club,
                                lighting_exterior: this.state.lighting_exterior,
                                lighting_burned_out: this.state.lighting_burned_out,
                                lighting_restaurant: this.state.lighting_restaurant,
                                location_observation: this.state.location_observation,
                                incident_type: this.state.type,
                                event_id: this.state.event_id,

                                incident_involved: this.state.incident_involved,
                                immediate_mediation: this.state.immediate_mediation,
                                contractor_dispatch: this.state.contractor_dispatch,
                                property_other_details: this.state.property_other_details,
                                first_aid: this.state.first_aid,
                                paramedics_called: this.state.paramedics_called,
                                offsite_emergency_care: this.state.offsite_emergency_care,
                                transported_by: this.state.transported_by,
                                transported_others: this.state.transported_others,
                                injured_body: this.state.injured_body,
                                injured_left: this.state.injured_left,
                                injured_right: this.state.injured_right,
                                observations: this.state.observations,
                                observations_others: this.state.observations_others,
                                clothes_contribute: this.state.clothes_contribute,
                                conditions: this.state.conditions,
                                condition_other: this.state.condition_other,
                                medical_other_relevant: this.state.medical_other_relevant,
                                medical_disposition: this.state.medical_disposition,
                                medical_other_details: this.state.medical_other_details,


                                police_called: this.state.police_called,
                                police_ejected: this.state.police_ejected,
                                police_report: this.state.police_report,
                                police_officer: this.state.police_officer,
                                blood_alcohol: this.state.blood_alcohol,
                                police_arrested: this.state.police_arrested,
                                names_of_arrested: this.state.names_of_arrested,
                                charges: this.state.charges,
                                arrest_details: this.state.arrest_details,
                                witnesses: this.state.witnesses,
                                staffWitnesses: this.state.staffWitnesses,

                                additional_observations: this.state.additional_observations,
                                investigating_manager_name: this.state.investigating_manager_name,
                                investigating_manager_signature: this.state.investigating_manager_signature,
                                general_manager_name: this.state.general_manager_name,
                                general_manager_signature: this.state.general_manager_signature,
                                linked_files: newLinkedFiles,

                                autoEmails: this.state.autoEmails,
                                refusal_of_medical_treatment_form: refusal_of_medical_treatment_form
                              }

        var params = {
                        auth_username: this.state.user_auth,
                        license: this.state.license,
                        token: this.state.token,
                        sub_user_id: this.state.loginResponse.data[0].recno,
                        date_added: moment(this.state.date_added).format("YYYY-MM-DD hh:mm:ss"),
                        event_id: this.state.event_id,
                        facility_id: this.state.facility_id,
                        facility_location_id: this.state.facility_location_id,
                        incident_form_type: "live_nation",
                        individuals_data: JSON.stringify(this.state.individuals_data),
                        location_description: this.state.location_description,
                        other_form_data: JSON.stringify(other_form_data),
                        signature_general_manager: {},
                        signature_investigating_manager: {},
                        files: this.state.files,

                      }

        if(this.props.itemToEdit != null) {
            this.setState({
                isSubmittingIncident: true,
                submitMessage: "Updating Incident..."
            });
            params.id = this.props.itemToEdit.id;
            IncidentService.sharedInstance.editCustomIncident(params)
            .then((response)=>{
                ToastStore.success( "Incident successfully edited.");
                  this.props.changeTab();
                  this.props.fetchIncidents();

                this.setState({
                    isSubmittingIncident: false,
                });

                this.resetValues();

            })
            .catch((err)=>{
                ToastStore.error( "Incident edit failed.");
                this.setState({
                    isSubmittingIncident: false,
                });
            })
        } else {
            this.setState({
                isSubmittingIncident: true,
                submitMessage: "Submitting Incident..."
            });
            IncidentService.sharedInstance.addCustomIncident(params)
            .then((response)=>{
                this.setState({
                    isSubmittingIncident: false,
                });

                ToastStore.success( "Incident successfully submitted");
                this.props.changeTab();
                this.props.fetchIncidents();
                //clear fields
                this.resetValues();
                //Get newIncident from response?
                try{
                    var docDef = this.props.prepLiveNationPDFDocDefinition(response.new_incdent);
                    //pdfMake.createPdf(docDef).open();

                    this.props.makePDFBlob(docDef, (blob)=> {
                         let emailParams = {
                            "pdf_blob":blob,
                            "emails": this.state.autoEmails
                        };

                        this.sendEmail(emailParams);
                    });
                }
                catch(e){
                    console.log("PDF generateion & send email error", e);
                }
            })
            .catch((err)=>{
                console.log("fail, error: ", err);
                ToastStore.error( "Incident submission failed");

                this.setState({
                    isSubmittingIncident: false,
                });
            })
        }
    }

    handleAddFile = () =>{
        this.refs.fileUploader.click();
    }

    handleFileChange = (e) =>{
        const {files} = this.state;
        const file = e.target.files[0];

        files.push(file);

        this.setState({ files });
    }

    handleAddGuest = () =>{
        const {individuals_data} = this.state;

        individuals_data.push({role: "guest"});

        this.setState({ individuals_data });
    }

    handleRepeatOffender = () => {
        this.setState({ showRepeatOffender: true });
    }

    onChangeSearchOffender = (e) =>{
        const value = e.target.value;
        if(this.timeout) {
            clearTimeout(this.timeout);
        }
        this.setState({search_offender: value});
        this.timeout = setTimeout(() => {
            this.fetchOffenders(value)

        }, 300);
    }

    fetchOffenders = (value) => {
        const that = this;
        IncidentService.sharedInstance.getAllRepeatOffenderByName(value)
        .then(res => {
            if(that._isMounted){
                const offenders = [];

                if(res && res.length){
                    for(let x = 0; x < (res).length; x++){
                        const {field_data,location_name,facility_name,event_name,date_added} = res[x];
                        const date = moment(date_added,'YYYY-MM-DD hh:mm:ss').format('MMMM DD, YYYY hh:mm:ss');
                        const data = JSON.parse(field_data);
                        const {name,role,address,height,weight,employer,work_phone,eye,hair,birthday,expiration} = data;

                        const offender = {
                            eye,
                            hair,
                            name,
                            date,
                            role,
                            address,
                            height,
                            weight,
                            employer,
                            work_phone,
                            event_name,
                            facility_name,
                            location_name,
                            birthday,
                            expiration
                        };

                        offenders.push(offender);
                    }
                }

                that.setState({ offenders });
            }
        });
    }

    getAllRepeatOffenderByName(){
        // let name = "";
        // IncidentService.sharedInstance.getAllRepeatOffenderByName(name)
        // .then((response)=>{

        //     var responseData = JSON.stringify(response);
        //     this.tableData.rows = [];

        //     response.map((item)=>{
        //         var item_data = {
        //             "id": UsersService.sharedInstance.returnEmptyIfNull(item.id),
        //             "name":  UsersService.sharedInstance.returnEmptyIfNull(item.field_data.name),
        //             "venue": UsersService.sharedInstance.returnEmptyIfNull(item.first_name),
        //             "event_name": UsersService.sharedInstance.returnEmptyIfNull(item.last_name),
        //             "location_name": UsersService.sharedInstance.returnEmptyIfNull(item.branch),
        //         };
        //         this.tableData.rows.push(item_data);
        //     });
        //     this.setState({offender: this.tableData});
        // })
        // .catch((error)=>{
        //     console.log("Error fetching users", error);
        // });
    }

    getIncidentTitlte = (data) =>{
        try{
            const individuals_data = UtilsService.sharedInstance.formatJSON(data.individuals_data);
            const individual = individuals_data && individuals_data.length ? individuals_data[0] : false;

            const title = individual && individual.name ? individual.name : '';

            return title;
        }catch(err){
            console.error('Error',err);

            return '';
        }
    }

    prepForEdit() {
      var itemToEdit = this.props.itemToEdit;
      var other_form_data = UtilsService.sharedInstance.tryParseJSON(itemToEdit.other_form_data) ? JSON.parse(itemToEdit.other_form_data) : {};

      var refusal_of_medical_treatment_form = other_form_data.refusal_of_medical_treatment_form
                                        ? other_form_data.refusal_of_medical_treatment_form
                                        : other_form_data.refusal_of_medical_treatement_form
                                            ? other_form_data.refusal_of_medical_treatement_form
                                            : {};
      const linked_files = [];

      if(other_form_data.linked_files && other_form_data.linked_files.length){
        for(let x = 0; x < (other_form_data.linked_files).length; x++){
            const linked = other_form_data.linked_files[x];

            if(linked){
                const title = this.getIncidentTitlte(linked);

                linked.title = title;

                linked_files.push(linked);
            }
        }
      }

      var newState = {
                              address: other_form_data.address,
                              asset_damage: other_form_data.asset_damage,
                              damage_value: other_form_data.damage_value,
                              time_of_incident: other_form_data.time_of_incident,
                              time_security_arrived: other_form_data.time_security_arrived,
                              time_police_arrived: other_form_data.time_police_arrived,
                              tape_on_file: other_form_data.tape_on_file,
                              location_desc: other_form_data.location_desc,
                              occupancy: other_form_data.occupancy,
                              occupancy_other: other_form_data.occupancy_other,
                              lighting_club: other_form_data.lighting_club,
                              lighting_exterior: other_form_data.lighting_exterior,
                              lighting_burned_out: other_form_data.lighting_burned_out,
                              lighting_restaurant: other_form_data.lighting_restaurant,
                              location_observation: other_form_data.location_observation,
                              type: other_form_data.incident_type,

                              incident_involved: other_form_data.incident_involved,
                              immediate_mediation: other_form_data.immediate_mediation,
                              contractor_dispatch: other_form_data.contractor_dispatch,
                              property_other_details: other_form_data.property_other_details,
                              first_aid: other_form_data.first_aid,
                              paramedics_called: other_form_data.paramedics_called,
                              offsite_emergency_care: Array.isArray(other_form_data.offsite_emergency_care) ? other_form_data.offsite_emergency_care : [other_form_data.offsite_emergency_care], //if old non-array data, force into array
                              transported_by: other_form_data.transported_by,
                              transported_others: other_form_data.transported_others,
                              injured_body: other_form_data.injured_body,
                              injured_left: other_form_data.injured_left,
                              injured_right: other_form_data.injured_right,
                              observations: other_form_data.observations,
                              observations_others: other_form_data.observations_others,
                              clothes_contribute: other_form_data.clothes_contribute,
                              conditions: other_form_data.conditions,
                              condition_other: other_form_data.condition_other,
                              medical_other_relevant: other_form_data.medical_other_relevant,
                              medical_disposition: other_form_data.medical_disposition,
                              medical_other_details: other_form_data.medical_other_details,

                              police_called: other_form_data.police_called,
                              police_ejected: other_form_data.police_ejected,
                              police_report: other_form_data.police_report,
                              police_officer: other_form_data.police_officer,
                              blood_alcohol: other_form_data.blood_alcohol,
                              police_arrested: other_form_data.police_arrested,
                              names_of_arrested: other_form_data.names_of_arrested,
                              charges: other_form_data.charges,
                              arrest_details: other_form_data.arrest_details,
                              witnesses: other_form_data.witnesses ? other_form_data.witness : [],
                              staffWitnesses: other_form_data.staffWitnesses ? other_form_data.staffWitnesses : [{},{}],

                              additional_observations: other_form_data.additional_observations,
                              investigating_manager_name: other_form_data.investigating_manager_name,
                              investigating_manager_signature: other_form_data.investigating_manager_signature,
                              general_manager_name: other_form_data.general_manager_name,
                              general_manager_signature: other_form_data.general_manager_signature,
                              linked_files: linked_files,

                              autoEmails: this.state.autoEmails,
                              refusal_of_medical_treatment_form: other_form_data.refusal_of_medical_treatment_form,

                              refusal_name: refusal_of_medical_treatment_form ? refusal_of_medical_treatment_form.refusal_individual_name : this.refusal_individual_name,
                              refusal_witnesses: refusal_of_medical_treatment_form ? refusal_of_medical_treatment_form.refusal_witnesses : "",
                              refusal_condition: refusal_of_medical_treatment_form ? refusal_of_medical_treatment_form.refusal_condition : "",
                              refusal_injury: refusal_of_medical_treatment_form ? refusal_of_medical_treatment_form.refusal_injured_parts_details : this.refusal_injured_parts_details,
                              refusal_incident_details: refusal_of_medical_treatment_form ? refusal_of_medical_treatment_form.refusal_incident_details : "",
                              refusal_date: refusal_of_medical_treatment_form ? refusal_of_medical_treatment_form.refusal_date : this.state.date_added,
                              refusal_venue: refusal_of_medical_treatment_form.refusal_facility_location ||  this.refusal_facility_location,
                              refusal_signature:  refusal_of_medical_treatment_form.refusal_parent_signature || "",
                              refusal_parent_signature:refusal_of_medical_treatment_form.refusal_parent_signature || "",
                            }

        newState["date_added"] = new Date(moment(itemToEdit.date_added).format("YYYY-MM-DD hh:mm:ss"));
        newState["event_id"] = this.props.getRecnoForName(itemToEdit.event_name, "Event");
        newState["facility_id"] = this.props.getRecnoForName(itemToEdit.facility_name, "Facility");
        newState["facility_location_id"] = itemToEdit.facility_location_id;
        newState["individuals_data"] = UtilsService.sharedInstance.tryParseJSON(itemToEdit.individuals_data) ? JSON.parse(itemToEdit.individuals_data) : [];
        newState["location_description"] = itemToEdit.location_description;
        newState["signature_general_manager"] = {};//Add from item later.
        newState["signature_investigating_manager"] = {};
        newState["files"] = UtilsService.sharedInstance.tryParseJSON( itemToEdit.attachments_data) ? JSON.parse(itemToEdit.attachments_data) : [];


        // Refusal Form:
        if (other_form_data.refusal_of_medical_treatment_form){
            let refusal_data = other_form_data.refusal_of_medical_treatment_form;
            newState["refusal_name"] = refusal_data.refusal_condition;
            newState["refusal_incident_details"] = refusal_data.refusal_incident_details;
            newState["refusal_signature"] = refusal_data.refusal_signature;
            newState["refusal_parent_signature"] = refusal_data.refusal_parent_signature;
            newState["refusal_witnesses"] = refusal_data.refusal_witnesses;
            newState["refusal_condition"] = refusal_data.refusal_condition;

            // newState["refusal_injury"] = refusal_data.refusal_injury;
        }

        const {tabs} = this.state;

        // if (this.state.first_aid == false) {
        //     console.log('should render refusal section');
        //     tabs["refusal"] = true;

        //     this.setState({ tabs });
        // }

        //setting tabs in edit
        if(Array.isArray(newState["type"])){
            newState["type"].map((type) => {
                if(type == "Medical"){
                    tabs["medical"] = true;
                }
                if(type == "Police/Security"){
                    tabs["police"] = true;
                }
                if(type == "Property Damage"){
                    tabs["property"] = true;
                }
                this.setState({ tabs });
            })
        }

        var newTabs = this.state.tabs;

        if(other_form_data.first_aid === "Declined") {
          newTabs["refusal"] = true;
        }

      this.setState(newState)
    }

    resetValues = () => {

        var newState = {
                                tab:'incident',
                                tabs:{
                                    incident:true,
                                    guest:true,
                                    property:false,
                                    medical:false,
                                    police:false,
                                    refusal: false,
                                    sign:true
                                },
                                individual_count: 1,
                                section: 1,

                                address: null,
                                asset_damage: null,
                                damage_value: null,
                                time_of_incident: null,
                                time_security_arrived: null,
                                time_police_arrived: null,
                                tape_on_file: false,
                                location_desc: "",
                                occupancy: null,
                                occupancy_other: "",
                                lighting_club: "",
                                lighting_exterior: "",
                                lighting_burned_out: "",
                                lighting_restaurant: "",
                                location_observation: "",
                                type: [],

                                incident_involved: [],
                                immediate_mediation: "",
                                contractor_dispatch: "",
                                property_other_details: "",
                                first_aid: "",
                                paramedics_called: "",
                                offsite_emergency_care: "",
                                transported_by: "",
                                transported_others: "",
                                injured_body: "",
                                injured_left: "",
                                injured_right: "",
                                observations: "",
                                observations_others: "",
                                clothes_contribute: "",
                                conditions: "",
                                condition_other: "",
                                medical_other_relevant: "",
                                medical_disposition: "",
                                medical_other_details: "",

                                police_called: "",
                                police_ejected: "",
                                police_report: "",
                                police_officer: "",
                                blood_alcohol: "",
                                police_arrested: "",
                                names_of_arrested: "",
                                charges: "",
                                arrest_details: "",
                                witnesses: [],
                                staffWitnesses: [],

                                additional_observations: "",
                                investigating_manager_name: "",
                                investigating_manager_signature: "",
                                general_manager_name: "",
                                general_manager_signature: "",
                                //linked_files: newLinkedFiles,

                                autoEmails: "",
                              }

        newState["date_added"] = new Date();
        newState["event_id"] = "";
        newState["facility_id"] = "";
        newState["facility_location_id"] = "";
        newState["individuals_data"] = [];
        newState["location_description"] = "";
        newState["signature_general_manager"] = {};//Add from item later.
        newState["signature_investigating_manager"] = {};
        newState["files"] = [];

          // newState["files"].map((file) => {
          //    console.log("file", UsersService.sharedInstance.createFileFromURL(file.path));
          // })

        this.refusal_injured_parts_details = "";
        this.refusal_individual_name = "";
        this.refusal_facility_location = "";

        this.setState(newState)
    }

    sendEmail(params){
        let emailParams = {
          file: params.pdf_blob,
          emails: params.emails //array of emails
        }
        if(!params.emails){
            return false;
        }
        EmailService.sharedInstance.sendIncidentReportToEmails(emailParams).then((response)=>{
        })
        .catch((err)=>{
          ToastStore.error("Email submission!");
          console.log("error: ", err);
        })
    }
}

export default LiveNationAddIncident;
